import React, { useEffect, useRef, useState } from "react";
import { Button, Spinner, Card, Row, Col, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { useAppContext } from "providers/appProvider";
import corner4 from "assets/img/illustrations/corner-4.png";
import Background from "components/common/background";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import SubtleBadge from 'components/common/subtleBadge';
import TaskDrawer from './taskDrawer';
import MobilePlanningList from './mobilePlanningList';
import {
  fetchRoleAndClaims, handleLoadingAndAccess, renderTaskStatusBadge, CleanerDeleteModal,
  deleteCleanerByOrderDetailId, fetchRoleMappings, deleteAllCleanerOrderDetailsForDay,
  sendLeaveReassignEmail, dispatchBatchNotification, buildTaskNotificationEntry, fetchFrequencyLabel,
  notifyLeaveDecision, notifyLeaveReassigned, buildConflictMapFromUnavailability,
  checkEmployeeAvailability, SchedulingIssuesModal
} from "../../assets/js/common";
import { useNavigate, useLocation } from "react-router-dom";
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { MdCloseFullscreen, MdOpenInFull } from 'react-icons/md';
import UnavailabilitySidepanel from './unavailabilitySidepanel';
import CreateOrderDrawer from "./createOrderDrawer";
import OrderDetailDrawer from "./orderDetailDrawer";
import useSocket from '../../hooks/useSocket';
import { USER_ROLES } from "config/roles.config";

const Calendar = () => {
  const {
    config: { isRTL, location: userLocation },
  } = useAppContext();
  const pageLoadHandledRef = useRef(false);
  const locationId = userLocation?.LocationId || userLocation?.locationId;
  const fetchInProgressRef = useRef(false);
  const [calendarReady, setCalendarReady] = useState(false);
  const pendingLocationReloadRef = useRef(false);
  const initialFetchDoneRef = useRef(false);
  const navigate = useNavigate();
  const calendarRef = useRef();
  const { t, i18n } = useTranslation();
  const [title, setTitle] = useState('');
  const [calendarApi, setCalendarApi] = useState({});
  const userRole = localStorage.getItem("UserRole");
  const isEmployeeView = sessionStorage.getItem("isEmployeeView") === 'true';
  const effectiveUserRole = userRole === USER_ROLES.EMPLOYEE || isEmployeeView ? USER_ROLES.EMPLOYEE : userRole;
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [initialEvents, setInitialEvents] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(true);
  const [showHoursHeader, setShowHoursHeader] = useState(true);
  const [resourceList, setResourceList] = useState([]);
  const clickedSubtasksRef = useRef(new Set());
  const [isLoading, setIsLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const [visibleStartDate, setVisibleStartDate] = useState(null);
  const [visibleEndDate, setVisibleEndDate] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [locationChangeLoading, setLocationChangeLoading] = useState(false);
  const [expandAllTasks, setExpandAllTasks] = useState(false);
  const [currentView, setCurrentView] = useState("");
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [allEmployees, setAllEmployees] = useState([]);
  const [selectedTimeRange, setSelectedTimeRange] = useState({
    start: null,
    end: null,
  });
  const [employeeList, setEmployeeList] = useState([]);
  const [showCleanerDeleteModal, setShowCleanerDeleteModal] = useState(false);
  const [selectedOrderDetailId, setSelectedOrderDetailId] = useState(null);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [selectedTaskDate, setSelectedTaskDate] = useState(null);
  const lastFetchKeyRef = useRef(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [mobileWeekStart, setMobileWeekStart] = useState(
    moment().startOf("isoWeek"),
  );
  const [mobileWeekEnd, setMobileWeekEnd] = useState(moment().endOf("isoWeek"));
  const [isReadOnly, setIsReadOnly] = useState(false);
  const loadingStartTimeRef = useRef(null);
  const [leaveDrawerOpen, setLeaveDrawerOpen] = useState(false);
  const [selectedLeaveData, setSelectedLeaveData] = useState(null);
  const [leaveDecisionLoading, setLeaveDecisionLoading] = useState(null);
  const [employeeOnLeaveModal, setEmployeeOnLeaveModal] = useState({
    show: false,
    employeeName: '',
    onConfirm: null,
    onCancel: null,
  });
  const [redirectDate, setRedirectDate] = useState(null);
  const location = useLocation();
  const [incomingNavState] = useState(() => {
    const stored = sessionStorage.getItem("pendingNavState");
    if (stored) {
      sessionStorage.removeItem("pendingNavState");
    }
    if (location.state) return location.state;
    if (stored) {
      try { return JSON.parse(stored); } catch { return null; }
    }
    return null;
  });
  const openTaskIdRef = useRef(null);
  const openTaskOrderIdRef = useRef(null);
  const openComplaintRef = useRef(false);
  const skipPastCheckRef = useRef(false);
  const skipTaskConflictCheckRef = useRef(false);
  const skipAllChecksRef = useRef(false);
  const [showCombinedWarningModal, setShowCombinedWarningModal] = useState(false);
  const [pendingCombinedDropInfo, setPendingCombinedDropInfo] = useState(null);
  const [showCreateOrder, setShowCreateOrder] = useState(false);
  const [showLeaveReassignModal, setShowLeaveReassignModal] = useState(false);
  const [pendingLeaveReassignInfo, setPendingLeaveReassignInfo] = useState(null);
  const [calendarView, setCalendarView] = useState("week");
  const [currentFilter, setCurrentFilter] = useState(
    effectiveUserRole === USER_ROLES.EMPLOYEE ? "employee" : "employees"
  );
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedOrderClient, setSelectedOrderClient] = useState(null);
  const [selectedClientPlanning, setSelectedClientPlanning] = useState("all");
  const skipNextDatesSetRef = useRef(false);
  const isNavigatingBackRef = useRef(false);
  const [conflictMap, setConflictMap] = useState({});
  const [createOrderPreFill, setCreateOrderPreFill] = useState({
    employeeId: null,
    clientId: null,
  });
  const [clientOrdersMap, setClientOrdersMap] = useState({});
  const [selectedDropdownOrderId, setSelectedDropdownOrderId] = useState(null);
  const isCalendarLoading = initialLoading || locationChangeLoading || loading || (!isMobileView && !calendarReady);
  const [isEmployeeViewToggle, setIsEmployeeViewToggle] = useState(true);
  const [orderDrawerOpen, setOrderDrawerOpen] = useState(false);
  const [selectedOrderEventData, setSelectedOrderEventData] = useState(null);
  const [selectedOrderDayEvents, setSelectedOrderDayEvents] = useState([]);
  const openReviewRef = useRef(false);
  const [drawerInitialSection, setDrawerInitialSection] = useState("overview");

  useSocket('order:created', (data) => {
    if (data.locationId !== locationId) return;

    lastFetchKeyRef.current = null; // must null this or dedup guard skips the fetch

    const api = calendarRef.current?.getApi();
    if (!api?.view) return;

    const start = moment(api.view.activeStart).toDate();
    const end = moment(api.view.activeEnd).subtract(1, 'day').toDate();
    fetchCalendarData(start, end, false, null, false);
  });

  useSocket('orderDetail:updated', (data) => {
    if (String(data.locationId) !== String(locationId)) return;
    lastFetchKeyRef.current = null;
    const api = calendarRef.current?.getApi();
    if (!api?.view) return;
    const start = moment(api.view.activeStart).toDate();
    const end = moment(api.view.activeEnd).subtract(1, 'day').toDate();
    fetchCalendarData(start, end, false, null, false);
  });

  useSocket('orderDetail:deleted', (data) => {
    if (data.locationId !== locationId) return;
    lastFetchKeyRef.current = null;
    const api = calendarRef.current?.getApi();
    if (!api?.view) return;
    const start = moment(api.view.activeStart).toDate();
    const end = moment(api.view.activeEnd).subtract(1, 'day').toDate();
    fetchCalendarData(start, end, false, null, false);
  });

  
  useSocket('unavailability:updated', (data) => {
  lastFetchKeyRef.current = null;

  const api = calendarRef.current?.getApi();
  if (!api?.view) return;

  const start = moment(api.view.activeStart).toDate();
  const end = moment(api.view.activeEnd)
    .subtract(1, 'day')
    .toDate();

  fetchCalendarData(start, end, false, null, false);
});

  const handleViewChange = (view) => {
    setCalendarView(view);

    if (view === "day" && userRole === USER_ROLES.CLIENT) {
      setExpandAllTasks(true);
    } else if (view === "week" && userRole === USER_ROLES.CLIENT) {
      setExpandAllTasks(false);
    }

    const api = calendarRef.current?.getApi();
    if (!api) return;

    if (view === "day") api.changeView("resourceTimelineDay");
    if (view === "week") api.changeView("resourceTimelineWeek");
    if (view === "month") api.changeView("dayGridMonth");
  };


  const handleViewToggle = (showEmployees) => {
    setIsEmployeeViewToggle(showEmployees);
    if (showEmployees) {
      setCurrentFilter("employees");
      setSelectedOrderId(null);
      setSelectedOrderClient(null);
      setSelectedDropdownOrderId(null);
      setSelectedClientPlanning("all");
      setSelectedEmployee(null);
    } else {
      setCurrentFilter("clients");
      setSelectedOrderId(null);
      setSelectedOrderClient(null);
      setSelectedDropdownOrderId(null);
      setSelectedClientPlanning("all");
      setSelectedEmployee(null);
    }
    lastFetchKeyRef.current = null;
    fetchInProgressRef.current = false;
    setTimeout(() => {
      const api = calendarRef.current?.getApi();
      if (api?.view) {
        const start = moment(api.view.activeStart).toDate();
        const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
        fetchCalendarData(start, end, false, showEmployees ? "employees" : "clients");
      }
    }, 50);
  };

  const orderSchema = yup.object({
    client: yup.string().required(t("clientRequired")),

    proposal: yup.string().required(t("proposalRequired")),

    orderStartDate: yup
      .date()
      .required(t("startDateRequired"))
      .typeError(t("invalidStartDate")),

    orderEndDate: yup
      .date()
      .nullable()
      .typeError(t("invalidEndDate"))
      .test(
        "endDate-after-startDate",
        t("endDateAfterStartDate"),
        function (endDate) {
          const { orderStartDate } = this.parent;
          if (endDate && orderStartDate) {
            return endDate >= orderStartDate; // SAME DATE ALLOWED
          }
          return true;
        },
      ),

    orderStartTime: yup
      .date()
      .required(t("startTimeRequired"))
      .typeError(t("invalidStartTime")),

    orderEndTime: yup
      .date()
      .nullable()
      .typeError(t("invalidEndTime"))
      .test(
        "endTime-after-startTime",
        t("endTimeAfterStartTime"),
        function (endTime) {
          const { orderStartTime, orderStartDate, orderEndDate } = this.parent;

          if (!endTime || !orderStartTime) return true;

          // If dates differ, skip time comparison
          if (
            orderStartDate &&
            orderEndDate &&
            moment(orderEndDate).isAfter(orderStartDate)
          ) {
            return true;
          }

          const start = moment(orderStartTime);
          const end = moment(endTime);

          return end.isAfter(start);
        },
      ),
  });

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(orderSchema),
    defaultValues: {
      client: "",
      proposal: "",
      orderStartDate: null,
      orderStartTime: null,
      orderEndDate: null,
      orderEndTime: null,
    },
  });

  const { control, setValue, getValues, reset: resetOrderForm, watch, trigger, formState: { errors } } = methods;

  // Update the viewName array based on effective user role
  const viewName = effectiveUserRole === USER_ROLES.EMPLOYEE
    ? [t("calendar.weekView"), t("calendar.clientOverview")]
    : [t("calendar.weekView"), t("calendar.employeeOverview")];

  const openTaskDrawerForEvent = (raw, section = "overview") => {
    setSelectedEvent(raw);
    setDrawerInitialSection(section);
    setDrawerOpen(true);

    const isCompleted = String(raw?.Status) === "2" || !!raw?.ActualEndTime;
    if (isCompleted && raw?.OrderDetailId) {
      axios.get(
        `${process.env.REACT_APP_API_URL}/orderRoute/orderDetail/${raw.OrderDetailId}/signature`,
        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
      ).then((res) => {
        setSelectedEvent((prev) =>
          prev && prev.OrderDetailId === raw.OrderDetailId
            ? { ...prev, ClientSignature: res.data?.ClientSignature || null }
            : prev
        );
      }).catch((err) => {
        console.error("Failed to fetch client signature:", err);
      });
    }
  };

  useEffect(() => {
    if (incomingNavState?.taskDate) {
      setRedirectDate(moment(incomingNavState.taskDate).toDate());
    }
  }, [incomingNavState]);

  useEffect(() => {
    if (incomingNavState?.openReview) {
      openReviewRef.current = true;
    }
  }, [incomingNavState]);

  useEffect(() => {
    if (incomingNavState?.openComplaint) {
      openComplaintRef.current = true;
    }
  }, [incomingNavState]);

  useEffect(() => {
    if (incomingNavState?.openTaskOrderId) {
      openTaskOrderIdRef.current = incomingNavState.openTaskOrderId;
    }
  }, [incomingNavState]);

  useEffect(() => {
    if (incomingNavState?.openTaskId) {
      openTaskIdRef.current = incomingNavState.openTaskId;
    }
  }, [incomingNavState]);

  useEffect(() => {
    if (!redirectDate) return;

    if (isMobileView) {
      setMobileWeekStart(moment(redirectDate).startOf("isoWeek"));
      setMobileWeekEnd(moment(redirectDate).endOf("isoWeek"));
      return;
    }

    const api = calendarRef.current?.getApi();
    if (!api) {
      return;
    }
    api.gotoDate(redirectDate);

    if (employeeList.length > 0) {
      const targetWeekStart = moment(redirectDate).startOf("isoWeek").toDate();
      const targetWeekEnd = moment(redirectDate).endOf("isoWeek").toDate();
      lastFetchKeyRef.current = null;
      pendingLocationReloadRef.current = false;
      fetchCalendarData(targetWeekStart, targetWeekEnd, true);
    }
  }, [redirectDate, isMobileView, calendarReady, employeeList.length]);

  useEffect(() => {
    const openTaskOrderId = openTaskOrderIdRef.current;
    if (!openTaskOrderId) return;
    const event = initialEvents.find(
      (e) =>
        e.extendedProps?.orderId === openTaskOrderId &&
        !e.extendedProps?.isLeave
    );
    if (!event) return;
    const raw = event.extendedProps?.rawData;
    if (!raw) return;
    openTaskDrawerForEvent(raw);
    openTaskOrderIdRef.current = null;
  }, [initialEvents]);

  useEffect(() => {

    const openTaskId = openTaskIdRef.current;
    if (!openTaskId) return;

    const event = initialEvents.find(e => e.id === openTaskId);
    if (!event) return;

    const raw = event.extendedProps?.rawData;
    if (!raw) return;

    openTaskDrawerForEvent(
      raw,
      openReviewRef.current ? "review" : openComplaintRef.current ? "complaint" : "overview"
    );
    openTaskIdRef.current = null;
    openReviewRef.current = false;
    openComplaintRef.current = false;

  }, [initialEvents]);

  // Add mobile view detection - UPDATED to handle view transitions
  useEffect(() => {
    const checkMobileView = () => {
      const mobile = window.innerWidth <= 768;

      // If switching between views, reset calendarReady for desktop
      if (mobile !== isMobileView && !mobile) {
        setCalendarReady(false);
      }

      setIsMobileView(mobile);

      // If switching to mobile view and we have data, set mobile week dates
      if (mobile && visibleStartDate && visibleEndDate) {
        setMobileWeekStart(moment(visibleStartDate).startOf("isoWeek"));
        setMobileWeekEnd(moment(visibleEndDate).endOf("isoWeek"));
      } else if (mobile && !visibleStartDate) {
        // Initial mobile load
        const today = moment();
        setMobileWeekStart(today.clone().startOf("isoWeek"));
        setMobileWeekEnd(today.clone().endOf("isoWeek"));
      }
    };

    checkMobileView();

    window.addEventListener("resize", checkMobileView);

    return () => window.removeEventListener("resize", checkMobileView);
  }, [visibleStartDate, visibleEndDate]);

  useEffect(() => {
    const handleViewTransition = () => {
      if (!isMobileView && !calendarReady && employeeList.length > 0 && !fetchInProgressRef.current) {
        lastFetchKeyRef.current = null;
        initialFetchDoneRef.current = false;
        pendingLocationReloadRef.current = false;

        setTimeout(() => {
          const api = calendarRef.current?.getApi();
          if (api && api.view) {
            const start = moment(api.view.activeStart).toDate();
            const end = moment(api.view.activeEnd).subtract(1, "day").toDate();

            fetchCalendarData(start, end, true);
          } else {
            const start = moment().startOf("isoWeek").toDate();
            const end = moment().endOf("isoWeek").toDate();
            fetchCalendarData(start, end, true);
          }
        }, 200);
      }
    };

    handleViewTransition();
  }, [isMobileView, employeeList.length]);

  // Initialize mobile week dates when component mounts
  useEffect(() => {
    if (isMobileView && !mobileWeekStart) {
      const today = moment();
      setMobileWeekStart(today.clone().startOf("isoWeek"));
      setMobileWeekEnd(today.clone().endOf("isoWeek"));
    }
  }, [isMobileView]);

  useEffect(() => {
    const makeDraggable = (popover) => {
      const header = popover.querySelector('.fc-popover-header');
      if (!header || popover._dragInitialized) return;
      popover._dragInitialized = true;

      let startX, startY, origLeft, origTop;

      const onMouseDown = (e) => {
        const rect = popover.getBoundingClientRect();
        startX = e.clientX;
        startY = e.clientY;
        origLeft = rect.left;
        origTop = rect.top;
        popover.style.position = 'fixed';
        popover.style.left = `${origLeft}px`;
        popover.style.top = `${origTop}px`;
        popover.style.margin = '0';
        popover.style.zIndex = '9999';

        const onMouseMove = (e) => {
          popover.style.left = `${origLeft + e.clientX - startX}px`;
          popover.style.top = `${origTop + e.clientY - startY}px`;
        };

        const onMouseUp = () => {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      };

      header.style.cursor = 'move';
      header.addEventListener('mousedown', onMouseDown);
    };

    const handlePopoverEventClick = (popover) => {
      if (popover._clickInitialized) return;
      popover._clickInitialized = true;
      popover.querySelectorAll('.fc-event').forEach((el) => {
        el.addEventListener('mouseup', () => {
          setTimeout(() => {
            document.querySelectorAll('.fc-popover').forEach(p => p.remove());
          }, 100);
        });
      });
    };

    const observer = new MutationObserver(() => {
      document.querySelectorAll('.fc-popover').forEach((popover) => {
        makeDraggable(popover);
        handlePopoverEventClick(popover);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!calendarRef.current) return;

    const api = calendarRef.current.getApi();
    if (!api?.view) return;

    setTitle(getFormattedCalendarTitle(api.view, t));
  }, [i18n.language]);

  useEffect(() => {
    if (!locationId) return;
    const locationIdStored = localStorage.getItem("LocationId");
    const customerId = localStorage.getItem("customerId");
    const fetchAll = async () => {

      const [usersRes, clientsRes] = await Promise.all([
        axios.get(
        `${process.env.REACT_APP_API_URL}/userRoute/calendarUsers`,
        {
          params: { locationId: locationIdStored },
          headers: {
            Authorization: process.env.REACT_APP_BasicAuthSecret
          },
        }
      ),
        axios.get(`${process.env.REACT_APP_API_URL}/relationRoute/relations`, {
          params: { locationId: locationIdStored, customerId },
          headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
        }),
      ]);

      const employeesOnly = usersRes.data.filter(u =>
        u.roleDetails?.Name !== t("clientText") &&
        !u.IsDelete &&
        u.Status === "0" &&
        u.locations?.some(
          loc => String(loc.LocationId) === String(locationIdStored)
        )
      );

      setEmployeeList(employeesOnly);
      setAllEmployees(employeesOnly);

      // process clients
      const allClients = clientsRes.data || [];
      const filteredClients = effectiveUserRole !== USER_ROLES.EMPLOYEE
        ? allClients.filter(c => String(c.LocationId) === String(locationIdStored))
        : allClients;
      setClients(filteredClients.sort((a, b) => (a.Name || "").localeCompare(b.Name || "")));

    };

    fetchAll().catch(err => console.error("fetchAll error:", err));
  }, [locationId, i18n.language]);

  const handleViewDidMount = (viewInfo) => {
    const calendarEl = viewInfo.el;

    const headerScroller = calendarEl.querySelector(
      ".fc-scrollgrid-section-header .fc-scroller"
    );

    if (headerScroller) {
      headerScroller.style.overflow = "visible";
    }

    const bodyScroller = calendarEl.querySelector(
      ".fc-scrollgrid-section-body .fc-scroller"
    );

    if (bodyScroller) {
      bodyScroller.style.overflowX = "auto";
      bodyScroller.style.overflowY = "hidden";
    }
    const style = document.createElement("style");
    style.textContent = `
    .fc-timeline-lane:last-child { border-bottom: 1px solid var(--fc-border-color, #dee2e6) !important; }
    .fc-datagrid-cell-frame:last-child { border-bottom: 1px solid var(--fc-border-color, #dee2e6) !important; }
    .fc-datagrid-cell-frame { min-height: 56px !important; }
    .fc-datagrid-cell-cushion { min-height: 56px !important; padding-top: 4px !important; padding-bottom: 4px !important; }
    .fc-timeline-lane { min-height: 56px !important; }
    .fc-resource-name-wrapper { min-height: 48px; }
    .fc-header-today .fc-day-label {
      color: #0d6efd !important;
      font-weight: 700 !important;
    }
  `;
    calendarEl.appendChild(style);
  };

  const handleSlotSelect = (info) => {
    const isResourceView = currentView === "resourceTimelineWeek" || currentView === "resourceTimelineDay";

    if (isResourceView && info.resource?.id) {
      const employeeId = info.resource.id;
      const leaveOnDate = getEmployeeLeaveOnDate(employeeId, info.start);
      if (leaveOnDate) {
        const leaveType = leaveOnDate.extendedProps?.leaveType;
        const leaveStatus = leaveOnDate.extendedProps?.leaveStatus;
        const employeeName = resourceList.find((r) => r.id === employeeId)?.title || allEmployees.find((e) => e.UserId === employeeId)?.Name || employeeId;
        setPendingCombinedDropInfo({
          info: { revert: () => { } },
          pendingSlotInfo: info,
          issues: [{ type: "leave", employeeName, leaveType, leaveStatus }],
        });
        setShowCombinedWarningModal(true);
        return;
      }
    }

    if (isResourceView) {
      const dateOnly = moment(info.start).startOf('day').toDate();
      setSelectedTimeRange({ start: dateOnly, end: dateOnly, dateOnly: true });
    } else {
      const dateOnly = moment(info.start).startOf('day').toDate();
      setSelectedTimeRange({ start: dateOnly, end: dateOnly, dateOnly: true, isWeekView: true });
    }

    if (currentFilter === "clients" && !selectedOrderId) {
      setCreateOrderPreFill({ clientId: info.resource?.id || null, employeeId: null });
    } else {
      const derivedClientId = selectedOrderId
        ? initialEvents
          .find(e => e.extendedProps?.orderId === selectedOrderId && !e.extendedProps?.isLeave)
          ?.extendedProps?.rawData?.RelationId || null
        : null;
      setCreateOrderPreFill({ employeeId: info.resource?.id || null, clientId: derivedClientId });
    }

    setShowCreateOrder(true);
  };

  const fetchUnavailability = async (customerId, startDate, endDate) => {
  const role = localStorage.getItem("UserRole");
    if (role === USER_ROLES.CLIENT) return [];
    try {
      const formattedStart = moment(startDate).format("YYYY-MM-DD");
      const formattedEnd = moment(endDate).format("YYYY-MM-DD");

      const isEmpView = sessionStorage.getItem("isEmployeeView") === 'true';

      let response;
      if (isEmpView) {
        const userId = localStorage.getItem("UserId");
        response = await axios.get(
          `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/getWeeklyUnavailabilitiesForUser`,
          {
            params: { userId, startDate: formattedStart, endDate: formattedEnd },
            headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
          }
        );
      } else {
        response = await axios.get(
          `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/unavailabilityByCustomerIdWithDate`,
          {
            params: { customerId, startDate: formattedStart, endDate: formattedEnd },
            headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
          }
        );
      }

      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching unavailability:", error);
      return [];
    }
  };

  const buildLeaveEvents = (unavailabilities = [], employees = [], clientResourceIds = [], isDrillDownOverride = null, t) => {
    if (!unavailabilities.length) return [];
    const isDrillDown = isDrillDownOverride !== null ? isDrillDownOverride : !!selectedOrderId;

    const isEmpToggleActive = isDrillDownOverride === false && !selectedOrderId;
    if (effectiveUserRole !== USER_ROLES.EMPLOYEE && !isDrillDown && !isEmployeeViewToggle && !isEmpToggleActive) {
      return [];
    }

    const events = [];

    unavailabilities.forEach((leave, idx) => {
      const employeeId = leave.UserId;

      const leaveType = (leave.Type || leave.type || "").toLowerCase().trim();
      const leaveStatus = (leave.Status || leave.status || "Pending").trim();
      const statusLower = leaveStatus.toLowerCase();
      if (statusLower === "rejected") return;

      const endExclusive = moment(leave.EndDate || leave.endDate)
        .add(1, "day")
        .format("YYYY-MM-DD");
      const startDate = moment(leave.StartDate || leave.startDate).format("YYYY-MM-DD");

      if (!startDate || !employeeId) return;

      const isSickness = leaveType === "sickness";
      const isRedPill = isSickness || statusLower === "approved" || statusLower === "pre-approved";
      const bgClass = isRedPill ? "leave-bg-sick" : "leave-bg-vacation";
      const icon = isSickness ? "🤒" : "🏖️";
      const label = isSickness ? t("sickLeave") : t("vacation");

      if (isDrillDown && effectiveUserRole !== USER_ROLES.EMPLOYEE) {
        events.push({
          id: `leave-bg-${idx}-${employeeId}`,
          title: "",
          start: startDate,
          end: endExclusive,
          resourceId: employeeId,
          display: "background",
          editable: false,
          startEditable: false,
          durationEditable: false,
          classNames: [bgClass],
          extendedProps: { isLeave: true, isLeaveBg: true, employeeId },
        });

        events.push({
          id: `leave-badge-${idx}-${employeeId}`,
          title: `${icon} (${leaveStatus})`,
          start: startDate,
          end: endExclusive,
          resourceId: employeeId,
          display: "auto",
          editable: true,
          startEditable: true,
          durationEditable: false,
          classNames: ["leave-event-transparent"],
          extendedProps: {
            isLeave: true,
            isLeaveBadge: true,
            leaveType,
            leaveStatus,
            icon,
            label,
            isRedPill,
            leaveRawData: leave,
            employeeId,
          },
        });

      } else if (effectiveUserRole === USER_ROLES.EMPLOYEE) {
        const relatedClientIds = clientResourceIds.filter(Boolean);

        relatedClientIds.forEach((resourceId, rIdx) => {
          events.push({
            id: `leave-bg-${idx}-${rIdx}-${employeeId}`,
            title: "",
            start: startDate,
            end: endExclusive,
            resourceId,
            display: "background",
            editable: false,
            startEditable: false,
            durationEditable: false,
            classNames: [bgClass],
            extendedProps: { isLeave: true, isLeaveBg: true, employeeId },
          });
        });

        if (relatedClientIds.length > 0) {
          events.push({
            id: `leave-badge-${idx}-0-${employeeId}`,
            title: `${icon} ${label} (${leaveStatus})`,
            start: startDate,
            end: endExclusive,
            resourceId: relatedClientIds[0],
            display: "auto",
            editable: true,
            startEditable: true,
            durationEditable: false,
            classNames: ["leave-event-transparent"],
            extendedProps: {
              isLeave: true,
              isLeaveBadge: true,
              leaveType,
              leaveStatus,
              icon,
              label,
              isRedPill,
              leaveRawData: leave,
              employeeId,
            },
          });
        }

      } else {
        // Admin employee overview (non-drilldown): resources are EMPLOYEES
        events.push({
          id: `leave-bg-${idx}-${employeeId}`,
          title: "",
          start: startDate,
          end: endExclusive,
          resourceId: employeeId,
          display: "background",
          editable: false,
          startEditable: false,
          durationEditable: false,
          classNames: [bgClass],
          extendedProps: { isLeave: true, isLeaveBg: true, employeeId },
        });

        events.push({
          id: `leave-badge-${idx}-${employeeId}`,
          title: `${icon} ${label} (${leaveStatus})`,
          start: startDate,
          end: endExclusive,
          resourceId: employeeId,
          display: "auto",
          editable: true,
          startEditable: true,
          durationEditable: false,
          classNames: ["leave-event-transparent"],
          extendedProps: {
            isLeave: true,
            isLeaveBadge: true,
            leaveType,
            leaveStatus,
            icon,
            label,
            isRedPill,
            leaveRawData: leave,
            employeeId,
          },
        });
      }
    });

    return events;
  };

  // const flattenOrderDetails = (orders) => {

  //   // Ensure orders is an array
  //   if (!Array.isArray(orders)) {
  //     return [];
  //   }

  //   if (orders.length === 0) {
  //     return [];
  //   }

  //   const flattened = orders.flatMap((order, index) => {

  //     // Check if order has OrderDetails
  //     if (order && Array.isArray(order.OrderDetails)) {
  //       const details = order.OrderDetails.map((detail) => ({
  //         ...detail,
  //         ProposalId: order.ProposalId,
  //         RelationId: order.RelationId,
  //         WorkType: order.WorkType,
  //         TemplateName: order.TemplateName,
  //         OrderNumber: order.OrderNumber,
  //         OrderStatus: order.Status, 
  //         OrderStartTime: order.StartTime || null,
  //         OrderEndTime: order.EndTime || null,
  //         OrderStartDate: order.StartDate,  
  //         OrderEndDate: order.EndDate,
  //       }));
  //       return details;
  //     } else if (order && order.OrderDetailId) {

  //       return [{
  //         ...order,
  //         ProposalId: order.ProposalId,
  //         RelationId: order.RelationId,
  //         WorkType: order.WorkType,
  //         TemplateName: order.TemplateName,
  //         OrderStatus: order.OrderStatus || order.Status,  // ← ADD THIS
  //       }];
  //     }
  //     return [];
  //   });
  //   return flattened;
  // };

  const flattenOrderDetails = (orders) => {
  if (!Array.isArray(orders) || orders.length === 0) {
    return [];
  }

  const flattened = [];

  for (const order of orders) {
    if (!order) {
      continue;
    }

    if (Array.isArray(order.OrderDetails)) {
      for (const detail of order.OrderDetails) {
        flattened.push({
          ...detail,
          ProposalId: order.ProposalId,
          RelationId: order.RelationId,
          WorkType: order.WorkType,
          TemplateName: order.TemplateName,
          OrderNumber: order.OrderNumber,
          OrderStatus: order.Status,
          OrderStartTime: order.StartTime || null,
          OrderEndTime: order.EndTime || null,
          OrderStartDate: order.StartDate,
          OrderEndDate: order.EndDate,
        });
      }

      continue;
    }

    // Keep backward compatibility with the existing behavior
    // in case an OrderDetail is passed directly.
    if (order.OrderDetailId) {
      flattened.push({
        ...order,
        ProposalId: order.ProposalId,
        RelationId: order.RelationId,
        WorkType: order.WorkType,
        TemplateName: order.TemplateName,
        OrderStatus: order.OrderStatus || order.Status,
      });
    }
  }

  return flattened;
};

  // const buildCalendarEvents = (
  //   details,
  //   taskMap,
  //   relationMap,
  //   cleanerMap,
  //   proposalTaskMap,
  //   subtaskMap,
  //   subtaskDefinitionMap,
  //   filterMode = null,
  // ) => {
  //   const dayMap = {
  //     monday: 1,
  //     tuesday: 2,
  //     wednesday: 3,
  //     thursday: 4,
  //     friday: 5,
  //     saturday: 6,
  //     sunday: 7,
  //   };
  //   const tasksByDate = {};
  //   details.forEach((detail) => {
  //     const dayIndex = dayMap[(detail.DayOfWeek || "").toLowerCase()] || 1;
  //     const taskDate = moment(detail.WeekStartDate).isoWeekday(dayIndex);
  //     const formattedDate = taskDate.format("YYYY-MM-DD");

  //     if (!tasksByDate[formattedDate]) tasksByDate[formattedDate] = [];
  //     tasksByDate[formattedDate].push({ ...detail, _taskDate: taskDate });
  //   });

  //   const events = [];

  //   Object.entries(tasksByDate).forEach(([date, tasks]) => {
  //     let currentTime = moment(`${date} 09:00`, "YYYY-MM-DD HH:mm");

  //     tasks.forEach((detail) => {
  //       const taskDate = detail._taskDate;

  //       const proposalTask = proposalTaskMap[detail.ProposalTaskId];
  //       const task = taskMap[proposalTask?.TaskId];
  //       const rawSubtasks = subtaskMap[detail.ProposalTaskId] || [];
  //       const subtasks = rawSubtasks.map((st) => ({
  //         ...st,
  //         Subtask:
  //           subtaskDefinitionMap[st.SubtaskId]?.Subtask || t("unnamedSubtask"),
  //       }));

  //       const relation = relationMap[detail.RelationId];
  //       const cleaner = cleanerMap[detail.CleanerId];
  //       const taskName = task?.TaskName || t("unnamedTask");
  //       const clientName = relation?.Name || t("unknownClient");

  //       let start, end;

  //       if (detail.StartTime) {
  //         const baseDate = taskDate.format("YYYY-MM-DD");

  //         const startMoment = moment.utc(detail.StartTime);
  //         const startHour = startMoment.hour();
  //         const startMinute = startMoment.minute();

  //         start = moment
  //           .utc(baseDate)
  //           .set({ hour: startHour, minute: startMinute });

  //         if (detail.EndTime) {
  //           const endMoment = moment.utc(detail.EndTime);
  //           const endHour = endMoment.hour();
  //           const endMinute = endMoment.minute();
  //           end = moment
  //             .utc(baseDate)
  //             .set({ hour: endHour, minute: endMinute });
  //         } else {
  //           end = start.clone().add(detail.DurationMinutes || 60, "minutes");
  //         }
  //       } else {
  //         start = currentTime.clone();
  //         end = start.clone().add(detail.DurationMinutes || 60, "minutes");
  //         currentTime = end.clone();
  //       }

  //       events.push({
  //         id: detail.OrderDetailId,
  //         hasExplicitEndTime: !!(detail.OrderEndTime),
  //         title: `${detail.TemplateName || taskName} - ${clientName}`,
  //         start: start.toISOString(),
  //         end: end.toISOString(),
  //         resourceId:
  //           effectiveUserRole === USER_ROLES.EMPLOYEE
  //             ? detail.RelationId
  //             : (() => {
  //               const activeFilter = filterMode !== null ? filterMode : currentFilter;
  //               if (activeFilter === "clients") return detail.RelationId;
  //               if (activeFilter === "employees") return detail.CleanerId;
  //               return detail.RelationId;
  //             })(),

  //         extendedProps: {
  //           orderId: detail.OrderId,
  //           clientName,
  //           workType: detail.WorkType,
  //           address: relation?.StreetName,
  //           startDate: start.format("YYYY-MM-DD"),
  //           endDate: end.format("YYYY-MM-DD"),
  //           rawData: {
  //             ...detail,
  //             TaskName: taskName,
  //             Relation: relation,
  //             Cleaner: cleaner,
  //             Subtasks: subtasks,
  //             OrderStatus: detail.OrderStatus,
  //           }
  //         }
  //       });
  //     });
  //   });

  //   return events;
  // };

  const buildCalendarEvents = (
  details,
  taskMap,
  relationMap,
  cleanerMap,
  proposalTaskMap,
  subtaskMap,
  subtaskDefinitionMap,
  filterMode = null,
) => {
  if (!Array.isArray(details) || details.length === 0) {
    return [];
  }

  const dayMap = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7,
  };

  const tasksByDate = {};

  // ---------------------------------------------------------
  // 1. Group details by calendar date
  // ---------------------------------------------------------
  for (const detail of details) {
    if (!detail) continue;

    const dayIndex =
      dayMap[String(detail.DayOfWeek || "").toLowerCase()] || 1;

    const taskDate = moment(detail.WeekStartDate).isoWeekday(dayIndex);
    const formattedDate = taskDate.format("YYYY-MM-DD");

    if (!tasksByDate[formattedDate]) {
      tasksByDate[formattedDate] = [];
    }

    tasksByDate[formattedDate].push({
      detail,
      taskDate,
    });
  }

  const events = [];

  // Resolve filter once instead of resolving it for every event.
  const activeFilter =
    filterMode !== null ? filterMode : currentFilter;

  const isEmployee = effectiveUserRole === USER_ROLES.EMPLOYEE;

  // ---------------------------------------------------------
  // 2. Build calendar events
  // ---------------------------------------------------------
  for (const [date, tasks] of Object.entries(tasksByDate)) {
    let currentTime = moment(`${date} 09:00`, "YYYY-MM-DD HH:mm");

    for (const item of tasks) {
      const detail = item.detail;
      const taskDate = item.taskDate;

      // -----------------------------------------------------
      // Lookup related data once
      // -----------------------------------------------------
      const proposalTask =
        proposalTaskMap[detail.ProposalTaskId] || null;

      const task =
        proposalTask?.TaskId
          ? taskMap[proposalTask.TaskId] || null
          : null;

      const relation =
        relationMap[detail.RelationId] || null;

      const cleaner =
        cleanerMap[detail.CleanerId] || null;

      const taskName =
        task?.TaskName || t("unnamedTask");

      const clientName =
        relation?.Name || t("unknownClient");

      // -----------------------------------------------------
      // Subtasks
      // -----------------------------------------------------
      const rawSubtasks =
        subtaskMap[detail.ProposalTaskId] || [];

      const subtasks =
        rawSubtasks.length > 0
          ? rawSubtasks.map((st) => ({
              ...st,
              Subtask:
                subtaskDefinitionMap[st.SubtaskId]?.Subtask ||
                t("unnamedSubtask"),
            }))
          : [];

      // -----------------------------------------------------
      // Calculate start/end
      // -----------------------------------------------------
      let start;
      let end;

      if (detail.StartTime) {
        const baseDate = taskDate.format("YYYY-MM-DD");

        const startMoment = moment.utc(detail.StartTime);

        start = moment
          .utc(baseDate)
          .set({
            hour: startMoment.hour(),
            minute: startMoment.minute(),
            second: 0,
            millisecond: 0,
          });

        if (detail.EndTime) {
          const endMoment = moment.utc(detail.EndTime);

          end = moment
            .utc(baseDate)
            .set({
              hour: endMoment.hour(),
              minute: endMoment.minute(),
              second: 0,
              millisecond: 0,
            });
        } else {
          end = start
            .clone()
            .add(detail.DurationMinutes || 60, "minutes");
        }
      } else {
        start = currentTime.clone();

        end = start
          .clone()
          .add(detail.DurationMinutes || 60, "minutes");

        currentTime = end.clone();
      }

      // -----------------------------------------------------
      // Resolve resourceId once
      // -----------------------------------------------------
      let resourceId;

      if (isEmployee) {
        resourceId = detail.RelationId;
      } else if (activeFilter === "clients") {
        resourceId = detail.RelationId;
      } else if (activeFilter === "employees") {
        resourceId = detail.CleanerId;
      } else {
        resourceId = detail.RelationId;
      }

      // -----------------------------------------------------
      // Create event
      // -----------------------------------------------------
      events.push({
        id: detail.OrderDetailId,

        hasExplicitEndTime: !!detail.OrderEndTime,

        title: `${detail.TemplateName || taskName} - ${clientName}`,

        start: start.toISOString(),

        end: end.toISOString(),

        resourceId,

        extendedProps: {
          orderId: detail.OrderId,
          clientName,
          workType: detail.WorkType,
          address: relation?.StreetName,

          startDate: start.format("YYYY-MM-DD"),
          endDate: end.format("YYYY-MM-DD"),

          rawData: {
            ...detail,

            TaskName: taskName,

            Relation: relation,

            Cleaner: cleaner,

            Subtasks: subtasks,

            OrderStatus: detail.OrderStatus,
          },
        },
      });
    }
  }

  return events;
};

  const getFormattedCalendarTitle = (view, t) => {
    if (!view) return "";

    const viewType = view.type;

    if (viewType === "timeGridWeek" || viewType === "resourceTimelineWeek") {
      const start = moment(view.currentStart);
      const end = moment(view.currentEnd).subtract(1, "day");

      const startMonth = t(`shortMonths.${start.format("MMMM").toLowerCase()}`);
      const endMonth = t(`shortMonths.${end.format("MMMM").toLowerCase()}`);

      return `${start.date()} ${startMonth} - ${end.date()} ${endMonth} ${end.year()}`;
    }

    if (viewType === "timeGridDay" || viewType === "resourceTimelineDay") {
      const date = moment(view.currentStart);
      const month = t(`shortMonths.${date.format("MMMM").toLowerCase()}`);
      return `${date.date()} ${month} ${date.year()}`;
    }

    // ADD THIS FOR MONTH
    if (viewType === "dayGridMonth") {
      const date = moment(view.currentStart);
      const month = t(`months.${date.format("MMMM").toLowerCase()}`);
      const year = date.year();

      return `${month} ${year}`;
    }
    return "";
  };

  useEffect(() => {
    const applyColumnHover = () => {
      const body = document.querySelector(".fc-timeline-body");
      if (!body) return;

      const slotCells = body.querySelectorAll(
        ".fc-timeline-slots td.fc-timeline-slot-lane"
      );

      if (!slotCells.length) return;

      // Get all resource lane rows
      const laneRows = body.querySelectorAll(
        "table.fc-scrollgrid-sync-table tbody tr td.fc-timeline-lane"
      );

      if (!laneRows.length) return;

      body
        .querySelectorAll(".fc-hover-overlay-container")
        .forEach((el) => el.remove());

      const bodyRect = body.getBoundingClientRect();
      const columns = [];
      slotCells.forEach((cell) => {
        const rect = cell.getBoundingClientRect();
        columns.push({
          date: cell.getAttribute("data-date"),
          left: rect.left - bodyRect.left,
          width: rect.width,
        });
      });

      // For each resource row, create an overlay container
      laneRows.forEach((lane) => {
        const laneRect = lane.getBoundingClientRect();
        const top = laneRect.top - bodyRect.top;
        const height = laneRect.height;
        const resourceId = lane.getAttribute("data-resource-id");

        const overlayContainer = document.createElement("div");
        overlayContainer.className = "fc-hover-overlay-container";
        overlayContainer.style.cssText = `
        position: absolute;
        top: ${top}px;
        left: 0px;
        width: 100%;
        height: ${height}px;
        pointer-events: none;
        z-index: 2;
      `;

        columns.forEach(({ date, left, width }) => {
          const cellOverlay = document.createElement("div");
          cellOverlay.className = "fc-hover-cell-overlay";
          cellOverlay.setAttribute("data-date", date);
          cellOverlay.setAttribute("data-resource-id", resourceId);
          cellOverlay.style.cssText = `
          position: absolute;
          top: 0px;
          left: ${left}px;
          width: ${width}px;
          height: 100%;
          pointer-events: all;
          cursor: pointer;
          transition: background-color 0.15s ease;
          box-sizing: border-box;
        `;

          cellOverlay.addEventListener("mouseenter", () => {
            cellOverlay.style.backgroundColor = "rgba(13, 110, 253, 0.07)";
            cellOverlay.style.outline = "1px solid rgba(13, 110, 253, 0.18)";
            cellOverlay.style.outlineOffset = "-1px";
          });

          cellOverlay.addEventListener("mouseleave", () => {
            cellOverlay.style.backgroundColor = "";
            cellOverlay.style.outline = "";
          });

          overlayContainer.appendChild(cellOverlay);
        });

        body.appendChild(overlayContainer);
      });

      body.style.position = "relative";
    };

    const timeout = setTimeout(applyColumnHover, 700);

    return () => {
      clearTimeout(timeout);
      document
        .querySelectorAll(".fc-hover-overlay-container")
        .forEach((el) => el.remove());
    };
  }, [initialEvents, resourceList, currentView, selectedEmployee, selectedClientPlanning]);

const fetchOrders = async (locationId, startDate, endDate, customerId) => {
    const formattedStart = moment(startDate).format("YYYY-MM-DD");
    const formattedEnd = moment(endDate).format("YYYY-MM-DD");

    const effectiveRole =
      userRole === USER_ROLES.EMPLOYEE ||
        sessionStorage.getItem("isEmployeeView") === "true"
        ? USER_ROLES.EMPLOYEE
        : userRole;
    const userId = localStorage.getItem("UserId");

    if (effectiveRole === USER_ROLES.EMPLOYEE && userId) {

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/orderRoute/byUserAndDateRange`,
        {
          params: { userId, startDate: formattedStart, endDate: formattedEnd, customerId },
          headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
        }
      );
      return { source: "employee", data: res.data };
    }

    if (effectiveRole === USER_ROLES.CLIENT) {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/orderRoute/clientCalendarData`,
        {
          params: { locationId, startDate: formattedStart, endDate: formattedEnd, customerId, userId },
          headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
        }
      );
      return { source: "client", data: res.data.data };
    }

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/orderRoute/calendarData`,
      {
        params: { locationId, startDate: formattedStart, endDate: formattedEnd, customerId },
        headers: { Authorization: process.env.REACT_APP_BasicAuthSecret },
      }
    );

    return { source: "admin", data: res.data };
  };

const buildCalendarProcessingData = (
  calendarEvents = [],
  unavailability = [],
  resources = [],
  effectiveUserRole
) => {
  // ---------------------------------------------------------
  // CLIENT ORDERS MAP
  // ---------------------------------------------------------
  const clientOrdersMap = {};

  // ---------------------------------------------------------
  // RESOURCE IDS
  // ---------------------------------------------------------
  const eventResourceIds = new Set();

  // Process calendar events only once
  for (const event of calendarEvents) {
    const raw = event?.extendedProps?.rawData;

    if (!raw) continue;

    // Resource ID
    if (event.resourceId) {
      eventResourceIds.add(event.resourceId);
    }

    // Client -> Orders
    const relationId = raw.RelationId;
    const orderId = raw.OrderId;

    if (!relationId || !orderId) {
      continue;
    }

    if (!clientOrdersMap[relationId]) {
      clientOrdersMap[relationId] = {};
    }

    if (!clientOrdersMap[relationId][orderId]) {
      clientOrdersMap[relationId][orderId] = {
        orderId,
        orderNumber:
          raw.OrderNumber ||
          orderId.slice(0, 8),
        templateName:
          raw.TemplateName || "Order",
        clientName:
          event.extendedProps?.clientName,
      };
    }
  }

  // ---------------------------------------------------------
  // Convert:
  //
  // {
  //   client1: {
  //      order1: {...},
  //      order2: {...}
  //   }
  // }
  //
  // into:
  //
  // {
  //   client1: [
  //      {...},
  //      {...}
  //   ]
  // }
  // ---------------------------------------------------------
  for (const relationId of Object.keys(clientOrdersMap)) {
    clientOrdersMap[relationId] =
      Object.values(clientOrdersMap[relationId]);
  }

  // ---------------------------------------------------------
  // RESOURCE IDS FOR LEAVE EVENTS
  // ---------------------------------------------------------
  let clientResourceIds;

  if (effectiveUserRole === USER_ROLES.EMPLOYEE) {
    const resourceIdSet = new Set(eventResourceIds);

    for (const resource of resources) {
      if (resource?.id) {
        resourceIdSet.add(resource.id);
      }
    }

    clientResourceIds =
      Array.from(resourceIdSet);
  } else {
    clientResourceIds =
      Array.from(eventResourceIds);
  }

  // ---------------------------------------------------------
  // CONFLICT MAP
  //
  // Do NOT manually build another conflict map here.
  // Your existing helper already does this.
  // ---------------------------------------------------------
  const conflictMap =
    buildConflictMapFromUnavailability(
      unavailability
    );

  return {
    clientOrdersMap,
    clientResourceIds,
    conflictMap,
  };
};

const areCalendarDataEqual = (prev, next) => {
  if (prev === next) return true;

  if (!prev || !next || prev.length !== next.length) {
    return false;
  }

  for (let i = 0; i < prev.length; i++) {
    if (prev[i] !== next[i]) {
      return false;
    }
  }

  return true;
};

const fetchCalendarData = async (
    startDate,
    endDate,
    isInitial = false,
    overrideFilter = null,
    showLoader = true
  ) => {
    if (
      fetchInProgressRef.current &&
      !isInitial &&
      !pendingLocationReloadRef.current
    ) {
      return;
    }

    if (!employeeList) return;

    fetchInProgressRef.current = true;
    if (showLoader) {
      isInitial ? setInitialLoading(true) : setLoading(true);
    }

    let source = "";
    let allDetails = [];
    let calendarEvents = [];
    let resources = [];

    try {
      const activeFilter =
        overrideFilter === "employees" ? "employees"
        : overrideFilter === "clients" ? "clients"
        : currentFilter === "employees" ? "employees"
        : "clients";

      const isDrillDownOverride =
        overrideFilter === "clients" ? false
        : overrideFilter === "drilldown" ? true
        : null;

      const customerId = localStorage.getItem("customerId");
      if (!customerId) throw new Error("Missing customerId");

      const response = await fetchOrders(locationId, startDate, endDate, customerId);
      source = response.source;
      const data = response.data;

      // ── BUILD LOOKUP MAPS FROM ENRICHED RESPONSE ─────────────────────────────
      let proposalTaskMap = {};
      let taskMap = {};
      let relationMap = {};
      let cleanerMap = {};
      let subtaskMap = {};
      let subtaskDefinitionMap = {};

      const normalizedData =
        source === "employee"
          ? data.data
          : data;

      // const ordersWithDetails = (normalizedData.orders || []).map((o) => ({
      //   ...o,
      //   OrderDetails: (normalizedData.orderDetails || []).filter(
      //     (d) => d.OrderId === o.OrderId
      //   ),
      // }));

      const orders = normalizedData.orders || [];
      const orderDetails = normalizedData.orderDetails || [];

      // Build OrderId -> OrderDetails map once.
      // This avoids scanning the complete orderDetails array
      // for every order.
      const orderDetailsByOrderId = {};

      for (const detail of orderDetails) {
        if (!orderDetailsByOrderId[detail.OrderId]) {
          orderDetailsByOrderId[detail.OrderId] = [];
        }

        orderDetailsByOrderId[detail.OrderId].push(detail);
      }

      const ordersWithDetails = orders.map((order) => ({
        ...order,
        OrderDetails: orderDetailsByOrderId[order.OrderId] || [],
      }));

      allDetails = flattenOrderDetails(ordersWithDetails);

      // allDetails = flattenOrderDetails(ordersWithDetails).filter((detail) => {
      //   const taskDate = moment(detail.WeekStartDate).isoWeekday(detail.DayOfWeek);

      //   return taskDate.isBetween(
      //     moment(startDate),
      //     moment(endDate),
      //     "day",
      //     "[]"
      //   );
      // });

      proposalTaskMap = normalizedData.meta?.proposalTaskMap || {};
      taskMap = normalizedData.meta?.taskMap || {};
      relationMap = normalizedData.meta?.relationMap || {};
      cleanerMap = normalizedData.meta?.cleanerMap || {};

      (normalizedData.orderDetails || []).forEach((d) => {
        subtaskMap[d.ProposalTaskId] = d.Subtasks || [];

        (d.Subtasks || []).forEach((s) => {
          if (s.SubtaskId) {
            subtaskDefinitionMap[s.SubtaskId] = {
              Subtask: s.Subtask || "",
            };
          }
        });
      });

      // ── NO DETAILS → EMPTY CALENDAR ──────────────────────────────────────────
      if (!allDetails.length) {
        const unavailability = await fetchUnavailability(customerId, startDate, endDate);
        const emptyDrillDownOverride =
          overrideFilter === "clients" ? false
          : typeof overrideFilter === "string" ? true
          : null;

        setInitialEvents(buildLeaveEvents(
          unavailability, employeeList, [],
          activeFilter === "employees" ? false : emptyDrillDownOverride, t
        ));

      if (effectiveUserRole === USER_ROLES.EMPLOYEE) {
          setResourceList([]);
        } else if (activeFilter === "employees") {
          setResourceList(userRole === USER_ROLES.CLIENT ? [] : buildResourcesFromAllEmployees(employeeList, {}));
          if (userRole === USER_ROLES.CLIENT) setAllEmployees([]);
        } else {
          setResourceList(buildResourcesFromClients(clients, []));
        }

        if (!isMobileView && isInitial) setCalendarReady(true);
        fetchInProgressRef.current = false;
        isInitial ? setInitialLoading(false) : setLoading(false);
        setLocationChangeLoading(false);
        return;
      }

      // ── BUILD CALENDAR EVENTS ─────────────────────────────────────────────────
      calendarEvents = buildCalendarEvents(
        allDetails, taskMap, relationMap, cleanerMap,
        proposalTaskMap, subtaskMap, subtaskDefinitionMap, activeFilter
      );

      // ── BUILD RESOURCES ───────────────────────────────────────────────────────
      // const workedTotals = getTotalWorkedHoursPerCleaner(calendarEvents);

      // ── BUILD EVENT STATS ONCE ─────────────────────────────────────
const eventStats = buildCalendarEventStats(calendarEvents);

// ── BUILD RESOURCES ───────────────────────────────────────────
if (effectiveUserRole === USER_ROLES.EMPLOYEE) {
  const clientIdsFromTasks = Array.from(
    eventStats.relationIds
  );

  const clientIdSet = new Set(clientIdsFromTasks);

  const filteredClients = clients.filter((client) =>
    clientIdSet.has(client.RelationNumber)
  );

  resources = buildResourcesFromClients(
    filteredClients,
    eventStats
  );

} else if (activeFilter === "employees") {

  resources = buildResourcesFromAllEmployees(
    employeeList,
    eventStats
  );

  if (userRole === USER_ROLES.CLIENT) {
  const assignedEmployeeIdSet = new Set(
    calendarEvents
      .map(
        (e) =>
          e.extendedProps
            ?.rawData
            ?.CleanerId
      )
      .filter(Boolean)
  );

  resources = resources.filter((r) =>
    assignedEmployeeIdSet.has(r.id)
  );

  const filteredAllEmployees =
    employeeList.filter((emp) =>
      assignedEmployeeIdSet.has(emp.UserId)
    );

  setAllEmployees((prevEmployees) =>
    areCalendarDataEqual(
      prevEmployees,
      filteredAllEmployees
    )
      ? prevEmployees
      : filteredAllEmployees
  );
}

} else {

  resources = buildResourcesFromClients(
    clients,
    eventStats
  );
}

     // ── FETCH LEAVE ───────────────────────────────────────────
      const unavailability = await fetchUnavailability(
        customerId,
        startDate,
        endDate
      );

      // ── STEP 8: PROCESS CALENDAR DATA ─────────────────────────
      const processingData =
        buildCalendarProcessingData(
          calendarEvents,
          unavailability,
          resources,
          effectiveUserRole
        );

      const {
        clientOrdersMap,
        clientResourceIds,
        conflictMap,
      } = processingData;

      // ── CONFLICT MAP ──────────────────────────────────────────
      setConflictMap(conflictMap);

      // ── CLIENT ORDERS MAP ─────────────────────────────────────
      setClientOrdersMap((prevMap) => {
        const prevKeys = Object.keys(prevMap || {});
        const nextKeys = Object.keys(clientOrdersMap || {});

        if (prevKeys.length !== nextKeys.length) {
          return clientOrdersMap;
        }

        for (const key of nextKeys) {
          const prevOrders = prevMap[key] || [];
          const nextOrders = clientOrdersMap[key] || [];

          if (prevOrders.length !== nextOrders.length) {
            return clientOrdersMap;
          }

          for (let i = 0; i < nextOrders.length; i++) {
            if (
              prevOrders[i]?.orderId !== nextOrders[i]?.orderId ||
              prevOrders[i]?.orderNumber !== nextOrders[i]?.orderNumber ||
              prevOrders[i]?.templateName !== nextOrders[i]?.templateName ||
              prevOrders[i]?.clientName !== nextOrders[i]?.clientName
            ) {
              return clientOrdersMap;
            }
          }
        }

        return prevMap;
      });

      // ── BUILD LEAVE EVENTS ────────────────────────────────────
      const leaveOverride =
        activeFilter === "employees"
          ? false
          : isDrillDownOverride;

      const leaveEvents = buildLeaveEvents(
        unavailability,
        employeeList,
        clientResourceIds,
        leaveOverride,
        t
      );

      // ── FINAL EVENTS ──────────────────────────────────────────
      const finalEvents =
        calendarEvents.length
          ? calendarEvents.concat(leaveEvents)
          : leaveEvents;

      // ── EVENTS ────────────────────────────────────────────────
      setInitialEvents((prevEvents) =>
        areCalendarDataEqual(
          prevEvents,
          finalEvents
        )
          ? prevEvents
          : finalEvents
      );

      // ── RESOURCES ─────────────────────────────────────────────
      setResourceList((prevResources) =>
        areCalendarDataEqual(
          prevResources,
          resources
        )
          ? prevResources
          : resources
      );

      isNavigatingBackRef.current = false;

      if (!isMobileView && isInitial) {
        setCalendarReady(true);
      }

    } catch (error) {
      console.error("Calendar load failed:", error);
      setInitialEvents(buildLeaveEvents([], employeeList, [], null, t));
      if (!isMobileView && isInitial) setCalendarReady(true);

    } finally {
      fetchInProgressRef.current = false;
      if (showLoader) {
        isInitial ? setInitialLoading(false) : setLoading(false);
      }
      setLocationChangeLoading(false);
      if (!isMobileView && isInitial) setCalendarReady(true);
    }
  };


//   const fetchCalendarData = async (
//     startDate,
//     endDate,
//     isInitial = false,
//     overrideFilter = null,
//     showLoader = true
//   ) => {
//     if (
//       fetchInProgressRef.current &&
//       !isInitial &&
//       !pendingLocationReloadRef.current
//     ) {
//       return;dar
//     }

//     if (!employeeList) return;

//     fetchInProgressRef.current = true;
//     if (showLoader) {
//       isInitial ? setInitialLoading(true) : setLoading(true);
//     }

//     let source = "";
//     let allDetails = [];
//     let calendarEvents = [];
//     let resources = [];

//     try {
//       const activeFilter =
//         overrideFilter === "employees" ? "employees"
//         : overrideFilter === "clients" ? "clients"
//         : currentFilter === "employees" ? "employees"
//         : "clients";

//       const isDrillDownOverride =
//         overrideFilter === "clients" ? false
//         : overrideFilter === "drilldown" ? true
//         : null;

//       const customerId = localStorage.getItem("customerId");
//       if (!customerId) throw new Error("Missing customerId");

//       const response = await fetchOrders(locationId, startDate, endDate, customerId);
//       source = response.source;
//       const data = response.data;

//       // ── BUILD LOOKUP MAPS FROM ENRICHED RESPONSE ─────────────────────────────
//       let proposalTaskMap = {};
//       let taskMap = {};
//       let relationMap = {};
//       let cleanerMap = {};
//       let subtaskMap = {};
//       let subtaskDefinitionMap = {};

//       const normalizedData =
//         source === "employee"
//           ? data.data
//           : data;

//       // const ordersWithDetails = (normalizedData.orders || []).map((o) => ({
//       //   ...o,
//       //   OrderDetails: (normalizedData.orderDetails || []).filter(
//       //     (d) => d.OrderId === o.OrderId
//       //   ),
//       // }));

//       const orders = normalizedData.orders || [];
//       const orderDetails = normalizedData.orderDetails || [];

//       // Build OrderId -> OrderDetails map once.
//       // This avoids scanning the complete orderDetails array
//       // for every order.
//       const orderDetailsByOrderId = {};

//       for (const detail of orderDetails) {
//         if (!orderDetailsByOrderId[detail.OrderId]) {
//           orderDetailsByOrderId[detail.OrderId] = [];
//         }

//         orderDetailsByOrderId[detail.OrderId].push(detail);
//       }

//       const ordersWithDetails = orders.map((order) => ({
//         ...order,
//         OrderDetails: orderDetailsByOrderId[order.OrderId] || [],
//       }));

//       allDetails = flattenOrderDetails(ordersWithDetails);

//       // allDetails = flattenOrderDetails(ordersWithDetails).filter((detail) => {
//       //   const taskDate = moment(detail.WeekStartDate).isoWeekday(detail.DayOfWeek);

//       //   return taskDate.isBetween(
//       //     moment(startDate),
//       //     moment(endDate),
//       //     "day",
//       //     "[]"
//       //   );
//       // });

//       proposalTaskMap = normalizedData.meta?.proposalTaskMap || {};
//       taskMap = normalizedData.meta?.taskMap || {};
//       relationMap = normalizedData.meta?.relationMap || {};
//       cleanerMap = normalizedData.meta?.cleanerMap || {};

//       (normalizedData.orderDetails || []).forEach((d) => {
//         subtaskMap[d.ProposalTaskId] = d.Subtasks || [];

//         (d.Subtasks || []).forEach((s) => {
//           if (s.SubtaskId) {
//             subtaskDefinitionMap[s.SubtaskId] = {
//               Subtask: s.Subtask || "",
//             };
//           }
//         });
//       });

//       // ── NO DETAILS → EMPTY CALENDAR ──────────────────────────────────────────
//       if (!allDetails.length) {
//         const unavailability = await fetchUnavailability(customerId, startDate, endDate);
//         const emptyDrillDownOverride =
//           overrideFilter === "clients" ? false
//           : typeof overrideFilter === "string" ? true
//           : null;

//         setInitialEvents(buildLeaveEvents(
//           unavailability, employeeList, [],
//           activeFilter === "employees" ? false : emptyDrillDownOverride, t
//         ));

//       if (effectiveUserRole === USER_ROLES.EMPLOYEE) {
//           setResourceList([]);
//         } else if (activeFilter === "employees") {
//           setResourceList(userRole === USER_ROLES.CLIENT ? [] : buildResourcesFromAllEmployees(employeeList, {}));
//           if (userRole === USER_ROLES.CLIENT) setAllEmployees([]);
//         } else {
//           setResourceList(buildResourcesFromClients(clients, []));
//         }

//         if (!isMobileView && isInitial) setCalendarReady(true);
//         fetchInProgressRef.current = false;
//         isInitial ? setInitialLoading(false) : setLoading(false);
//         setLocationChangeLoading(false);
//         return;
//       }

//       // ── BUILD CALENDAR EVENTS ─────────────────────────────────────────────────
//       calendarEvents = buildCalendarEvents(
//         allDetails, taskMap, relationMap, cleanerMap,
//         proposalTaskMap, subtaskMap, subtaskDefinitionMap, activeFilter
//       );

//       // ── BUILD RESOURCES ───────────────────────────────────────────────────────
//       // const workedTotals = getTotalWorkedHoursPerCleaner(calendarEvents);

//       // ── BUILD EVENT STATS ONCE ─────────────────────────────────────
// const eventStats = buildCalendarEventStats(calendarEvents);

// // ── BUILD RESOURCES ───────────────────────────────────────────
// if (effectiveUserRole === USER_ROLES.EMPLOYEE) {
//   const clientIdsFromTasks = Array.from(
//     eventStats.relationIds
//   );

//   const clientIdSet = new Set(clientIdsFromTasks);

//   const filteredClients = clients.filter((client) =>
//     clientIdSet.has(client.RelationNumber)
//   );

//   resources = buildResourcesFromClients(
//     filteredClients,
//     eventStats
//   );

// } else if (activeFilter === "employees") {

//   resources = buildResourcesFromAllEmployees(
//     employeeList,
//     eventStats
//   );

//   if (userRole === USER_ROLES.CLIENT) {
//     const assignedEmployeeIds =
//       eventStats.cleanerIds;

//     resources = resources.filter((resource) =>
//       assignedEmployeeIds.has(resource.id)
//     );

//     setAllEmployees(
//       employeeList.filter((emp) =>
//         assignedEmployeeIds.has(emp.UserId)
//       )
//     );
//   }

// } else {

//   resources = buildResourcesFromClients(
//     clients,
//     eventStats
//   );
// }

//       // ── FETCH LEAVE ───────────────────────────────────────────────────────────
//       const unavailability = await fetchUnavailability(customerId, startDate, endDate);

//       // const clientResourceIds = effectiveUserRole === USER_ROLES.EMPLOYEE
//       //   ? [...new Set([
//       //       ...calendarEvents.map((e) => e.resourceId).filter(Boolean),
//       //       ...resources.map((r) => r.id).filter(Boolean),
//       //     ])]
//       //   : [...new Set(calendarEvents.map((e) => e.resourceId).filter(Boolean))];

//       const clientResourceIds =
//         effectiveUserRole === USER_ROLES.EMPLOYEE
//           ? Array.from(
//               new Set([
//                 ...eventStats.relationIds,
//                 ...resources.map((r) => r.id).filter(Boolean),
//               ])
//             )
//           : Array.from(eventStats.relationIds);

//       const leaveOverride = activeFilter === "employees" ? false : isDrillDownOverride;
//       const leaveEvents = buildLeaveEvents(unavailability, employeeList, clientResourceIds, leaveOverride, t);

//       // ── CONFLICT MAP ──────────────────────────────────────────────────────────
//       // const newConflictMap = {};
//       // unavailability.forEach((leave) => {
//       //   const statusLower = (leave.Status || leave.status || "").toLowerCase();
//       //   if (statusLower === "rejected") return;
//       //   const employeeId = leave.UserId;
//       //   if (!employeeId) return;
//       //   let cursor = moment(leave.StartDate || leave.startDate);
//       //   const leaveEnd = moment(leave.EndDate || leave.endDate);
//       //   while (cursor.isSameOrBefore(leaveEnd, "day")) {
//       //     const dateStr = cursor.format("YYYY-MM-DD");
//       //     if (!newConflictMap[employeeId])
//       //       newConflictMap[employeeId] = { dates: new Set(), leaveData: leave };
//       //     newConflictMap[employeeId].dates.add(dateStr);
//       //     cursor.add(1, "day");
//       //   }
//       // });
//       // setConflictMap(buildConflictMapFromUnavailability(unavailability));

//       // ── CLIENT ORDERS MAP ─────────────────────────────────────────────────────
//       // const newClientOrdersMap = {};
//       // calendarEvents.forEach((e) => {
//       //   const raw = e.extendedProps?.rawData;
//       //   if (!raw?.RelationId || !raw?.OrderId) return;
//       //   if (!newClientOrdersMap[raw.RelationId]) newClientOrdersMap[raw.RelationId] = {};
//       //   if (!newClientOrdersMap[raw.RelationId][raw.OrderId]) {
//       //     newClientOrdersMap[raw.RelationId][raw.OrderId] = {
//       //       orderId: raw.OrderId,
//       //       orderNumber: raw.OrderNumber || raw.OrderId.slice(0, 8),
//       //       templateName: raw.TemplateName || "Order",
//       //       clientName: e.extendedProps?.clientName,
//       //     };
//       //   }
//       // });
//       // Object.keys(newClientOrdersMap).forEach((relId) => {
//       //   newClientOrdersMap[relId] = Object.values(newClientOrdersMap[relId]);
//       // });
//       // setClientOrdersMap(newClientOrdersMap);

//       // ── COMMIT ────────────────────────────────────────────────────────────────
//       setInitialEvents([...calendarEvents, ...leaveEvents]);
//       setResourceList(resources);
//       isNavigatingBackRef.current = false;
//       if (!isMobileView && isInitial) setCalendarReady(true);

//     } catch (error) {
//       console.error("Calendar load failed:", error);
//       setInitialEvents(buildLeaveEvents([], employeeList, [], null, t));
//       if (!isMobileView && isInitial) setCalendarReady(true);

//     } finally {
//       fetchInProgressRef.current = false;
//       if (showLoader) {
//         isInitial ? setInitialLoading(false) : setLoading(false);
//       }
//       setLocationChangeLoading(false);
//       if (!isMobileView && isInitial) setCalendarReady(true);
//     }
//   };

  // const buildResourcesFromClients = (clients = [], events = []) => {
  //   const today = moment().format("YYYY-MM-DD");

  //   const todayOrderSet = {};
  //   const weekOrderSet = {};

  //   events.forEach((event) => {
  //     const relationId = event.extendedProps?.rawData?.RelationId;
  //     const orderId = event.extendedProps?.orderId;
  //     if (!relationId || !orderId) return;

  //     const eventDate = moment(event.start).format("YYYY-MM-DD");
  //     const key = `${orderId}_${eventDate}`;

  //     if (!weekOrderSet[relationId]) weekOrderSet[relationId] = new Set();
  //     weekOrderSet[relationId].add(key);

  //     if (eventDate === today) {
  //       if (!todayOrderSet[relationId]) todayOrderSet[relationId] = new Set();
  //       todayOrderSet[relationId].add(key);
  //     }
  //   });

  //   return clients
  //     .map((client) => ({
  //       id: client.RelationNumber,
  //       title: client.Name,
  //       extendedProps: {
  //         todayOrders: todayOrderSet[client.RelationNumber]?.size || 0,
  //         weekOrders: weekOrderSet[client.RelationNumber]?.size || 0,
  //         isClient: true,
  //       },
  //     }))
  //     .sort((a, b) => {
  //       const aHasOrders = a.extendedProps.weekOrders > 0 ? 1 : 0;
  //       const bHasOrders = b.extendedProps.weekOrders > 0 ? 1 : 0;
  //       if (bHasOrders !== aHasOrders) return bHasOrders - aHasOrders;
  //       return a.title.localeCompare(b.title);
  //     });
  // };

const buildResourcesFromClients = (
  clients = [],
  eventStats = {}
) => {
  const todayOrderSet =
    eventStats.todayOrderSet || {};

  const weekOrderSet =
    eventStats.weekOrderSet || {};

  return clients
    .map((client) => ({
      id: client.RelationNumber,
      title: client.Name,

      extendedProps: {
        todayOrders:
          todayOrderSet[client.RelationNumber]?.size || 0,

        weekOrders:
          weekOrderSet[client.RelationNumber]?.size || 0,

        isClient: true,
      },
    }))
    .sort((a, b) => {
      const aHasOrders =
        a.extendedProps.weekOrders > 0 ? 1 : 0;

      const bHasOrders =
        b.extendedProps.weekOrders > 0 ? 1 : 0;

      if (bHasOrders !== aHasOrders) {
        return bHasOrders - aHasOrders;
      }

      return a.title.localeCompare(b.title);
    });
};

  const buildCalendarEventStats = (events = []) => {
  const stats = {
    workedTotals: {},
    taskCountMap: {},
    totalHoursMap: {},
    completedHoursMap: {},

    relationIds: new Set(),
    cleanerIds: new Set(),

    // Used by client resources
    todayOrderSet: {},
    weekOrderSet: {},
  };

  if (!Array.isArray(events) || events.length === 0) {
    return stats;
  }

  const today = moment().format("YYYY-MM-DD");

  const MS_PER_HOUR = 1000 * 60 * 60;

  for (const event of events) {
    if (!event) continue;

    const resourceId = event.resourceId;
    const raw = event.extendedProps?.rawData;

    if (!resourceId) continue;

    // -------------------------------------------------------
    // Duration
    // -------------------------------------------------------
    const startTime = new Date(event.start).getTime();
    const endTime = new Date(event.end).getTime();

    const durationHours =
      (endTime - startTime) / MS_PER_HOUR;

    // -------------------------------------------------------
    // Worked hours
    // -------------------------------------------------------
    stats.workedTotals[resourceId] =
      (stats.workedTotals[resourceId] || 0) + durationHours;

    // -------------------------------------------------------
    // Task count
    // -------------------------------------------------------
    stats.taskCountMap[resourceId] =
      (stats.taskCountMap[resourceId] || 0) + 1;

    // -------------------------------------------------------
    // Total scheduled hours
    // -------------------------------------------------------
    stats.totalHoursMap[resourceId] =
      (stats.totalHoursMap[resourceId] || 0) + durationHours;

    // -------------------------------------------------------
    // Completed hours
    // -------------------------------------------------------
    const detailStatus = String(
      raw?.Status ?? "0"
    ).toLowerCase();

    const isCompletedStatus =
      detailStatus === "2" ||
      detailStatus === "jobcomplete" ||
      detailStatus === "completed";

    if (isCompletedStatus) {
      stats.completedHoursMap[resourceId] =
        (stats.completedHoursMap[resourceId] || 0) +
        durationHours;
    }

    // -------------------------------------------------------
    // Relation IDs
    // -------------------------------------------------------
    const relationId = raw?.RelationId;

    if (relationId) {
      stats.relationIds.add(relationId);
    }

    // -------------------------------------------------------
    // Cleaner IDs
    // -------------------------------------------------------
    const cleanerId = raw?.CleanerId;

    if (cleanerId) {
      stats.cleanerIds.add(cleanerId);
    }

    // -------------------------------------------------------
    // Client order statistics
    // -------------------------------------------------------
    const orderId = event.extendedProps?.orderId;

    if (relationId && orderId) {
      const eventDate = moment(event.start).format("YYYY-MM-DD");

      const key = `${orderId}_${eventDate}`;

      if (!stats.weekOrderSet[relationId]) {
        stats.weekOrderSet[relationId] = new Set();
      }

      stats.weekOrderSet[relationId].add(key);

      if (eventDate === today) {
        if (!stats.todayOrderSet[relationId]) {
          stats.todayOrderSet[relationId] = new Set();
        }

        stats.todayOrderSet[relationId].add(key);
      }
    }
  }

  return stats;
};


  // const getTotalWorkedHoursPerCleaner = (events = []) => {
  //   const totals = {};

  //   events.forEach((event) => {
  //     const duration =
  //       (new Date(event.end).getTime() - new Date(event.start).getTime()) /
  //       (1000 * 60 * 60);
  //     totals[event.resourceId] = (totals[event.resourceId] || 0) + duration;
  //   });

  //   return totals;
  // };

  // const buildResourcesFromAllEmployees = (
  //   employees,
  //   workedTotals = {},
  //   calendarEvents = [],
  // ) => {
  //   const taskCountMap = {};
  //   const totalHoursMap = {};
  //   const completedHoursMap = {};

  //   calendarEvents.forEach((event) => {
  //     const cleanerId = event.resourceId;
  //     if (!cleanerId) return;

  //     taskCountMap[cleanerId] = (taskCountMap[cleanerId] || 0) + 1;

  //     const start = new Date(event.start);
  //     const end = new Date(event.end);
  //     const durationHours = (end - start) / (1000 * 60 * 60);
  //     totalHoursMap[cleanerId] = (totalHoursMap[cleanerId] || 0) + durationHours;

  //     const detailStatus = String(event.extendedProps?.rawData?.Status ?? "0").toLowerCase();
  //     const isCompletedStatus =
  //       detailStatus === "2" || detailStatus === "jobcomplete" || detailStatus === "completed";
  //     if (isCompletedStatus) {
  //       completedHoursMap[cleanerId] = (completedHoursMap[cleanerId] || 0) + durationHours;
  //     }
  //   });

  //   const employeesWithTasks = [];
  //   const employeesWithoutTasks = [];

  //   employees.forEach((emp) => {
  //     if (
  //       emp.RoleName?.toLowerCase() === USER_ROLES.CLIENT.toLowerCase() ||
  //       emp.IsDelete ||
  //       emp.Status !== "0"
  //     )
  //       return;

  //     const hasTask = (taskCountMap[emp.UserId] || 0) > 0;
  //     hasTask ? employeesWithTasks.push(emp) : employeesWithoutTasks.push(emp);
  //   });

  //   const sortByNameAsc = (a, b) =>
  //     (a.Name || "").localeCompare(b.Name || "", undefined, {
  //       sensitivity: "base",
  //     });

  //   employeesWithTasks.sort(sortByNameAsc);
  //   employeesWithoutTasks.sort(sortByNameAsc);

  //   return [...employeesWithTasks, ...employeesWithoutTasks].map((emp) => ({
  //     id: emp.UserId,
  //     title: emp.Name,
  //     extendedProps: {
  //       expectedHours: emp.FixedHours || 40,
  //       workedHours: workedTotals[emp.UserId] || 0,
  //       taskCount: taskCountMap[emp.UserId] || 0,
  //       totalHours: totalHoursMap[emp.UserId] || 0,
  //       completedHours: completedHoursMap[emp.UserId] || 0,
  //       scheduledHours: totalHoursMap[emp.UserId] || 0,
  //       hasData: (taskCountMap[emp.UserId] || 0) > 0,
  //     },
  //   }));
  // };

  const buildResourcesFromAllEmployees = (
  employees = [],
  eventStats = {}
) => {
  const taskCountMap = eventStats.taskCountMap || {};
  const totalHoursMap = eventStats.totalHoursMap || {};
  const completedHoursMap = eventStats.completedHoursMap || {};
  const workedTotals = eventStats.workedTotals || {};

  const employeesWithTasks = [];
  const employeesWithoutTasks = [];

  for (const emp of employees) {
    if (
      emp.RoleName?.toLowerCase() ===
        USER_ROLES.CLIENT.toLowerCase() ||
      emp.IsDelete ||
      emp.Status !== "0"
    ) {
      continue;
    }

    const hasTask =
      (taskCountMap[emp.UserId] || 0) > 0;

    if (hasTask) {
      employeesWithTasks.push(emp);
    } else {
      employeesWithoutTasks.push(emp);
    }
  }

  const sortByNameAsc = (a, b) =>
    (a.Name || "").localeCompare(
      b.Name || "",
      undefined,
      {
        sensitivity: "base",
      }
    );

  employeesWithTasks.sort(sortByNameAsc);
  employeesWithoutTasks.sort(sortByNameAsc);

  return [
    ...employeesWithTasks,
    ...employeesWithoutTasks,
  ].map((emp) => ({
    id: emp.UserId,
    title: emp.Name,

    extendedProps: {
      expectedHours: emp.FixedHours || 40,

      workedHours:
        workedTotals[emp.UserId] || 0,

      taskCount:
        taskCountMap[emp.UserId] || 0,

      totalHours:
        totalHoursMap[emp.UserId] || 0,

      completedHours:
        completedHoursMap[emp.UserId] || 0,

      scheduledHours:
        totalHoursMap[emp.UserId] || 0,

      hasData:
        (taskCountMap[emp.UserId] || 0) > 0,
    },
  }));
};

  const buildResourcesFromOrderEmployees = (events, orderId) => {

    const employeeMap = {};

    events.forEach(event => {

      const raw = event.extendedProps?.rawData;

      if (!raw || raw.OrderId !== orderId) return;

      const cleaner = raw.Cleaner;

      if (!cleaner) return;

      employeeMap[cleaner.UserId] = {
        id: cleaner.UserId,
        title: cleaner.Name,
        extendedProps: {
          isEmployee: true
        }
      };

    });

    return Object.values(employeeMap);
  };

  useEffect(() => {
    if (selectedEvent) {
      setDetailsLoading(false);
    }
  }, [selectedEvent]);

  useEffect(() => {
    pageLoadHandledRef.current = false;

    lastFetchKeyRef.current = null;
    initialFetchDoneRef.current = false;
    pendingLocationReloadRef.current = true;

    setInitialEvents([]);
    setResourceList([]);
    setCalendarReady(false);
    setLocationChangeLoading(true);

    calendarRef.current
      ?.getApi()
      ?.gotoDate(calendarRef.current.getApi().getDate());
  }, [locationId]);

  const getStatusColor = (status) => {
    const s = String(status);

    switch (s) {
      case "0":
        return "text-primary";     // Planned
      case "1":
        return "text-success";        // Inprogress
      case "2":
        return "text-success";     // Job complete
      case "3":
      case "4":
      case "5":
        return "text-secondary";   // Secondary cases
      case "6":
        return "text-danger";      // Cancelled
      case "7":
        return "text-warning";     // Incomplete
      default:
        return "text-dark";
    }
  };

  useEffect(() => {
    fetchRoleAndClaims({
      navigate,
      claimType: "planning",
      claimValue: "view",
      setHasAccess,
      setIsLoading,
    });
  }, [navigate]);

  useEffect(() => {
    const role = localStorage.getItem("UserRole");
    const isEmpView = sessionStorage.getItem("isEmployeeView") === 'true';
    setIsReadOnly(role === USER_ROLES.EMPLOYEE || role === USER_ROLES.CLIENT || isEmpView);
  }, []);

  const formatDurationLocalized = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const culture = localStorage.getItem("culture") || getDomainConfig().defaultLanguage;
    return `${hrs}${t("hourUnit")}${mins.toString().padStart(2, '0')}`;
  };

  const renderEventContent = (arg) => {
    const viewType = arg.view?.type;
    const isEmployeeView = effectiveUserRole === USER_ROLES.EMPLOYEE;
    const isClientView =
      currentFilter === "clients" && !isEmployeeViewToggle && !selectedOrderId;
    const data = arg.event.extendedProps;

    if (arg.event.extendedProps?.isLeave) {
      const isResourceView = viewType === "resourceTimelineWeek" || viewType === "resourceTimelineDay";
      if (!isResourceView) return null;
      if (arg.event.extendedProps?.isLeaveBg) return null;

      const { icon, leaveStatus, leaveType } = arg.event.extendedProps;
      const label = leaveType === "sickness" ? t("sickLeave") : t("vacation");
      const translatedStatus = t(`leaveStatus.${leaveStatus?.toLowerCase()}`) || leaveStatus;

      const isSick = leaveType === "sickness";
      const isApprovedVacation = leaveType === "vacation" && leaveStatus?.toLowerCase() === "approved";
      const isPending = leaveStatus?.toLowerCase() === "pending";

      const pillBg = (isSick || isApprovedVacation) ? "bg-danger" : "";
      const pillText = (isSick || isApprovedVacation) ? "text-white" : "text-warning-emphasis";
      const pillBorder = isPending ? "leave-pill-border-pending" : (isSick || isApprovedVacation) ? "" : "leave-pill-border-vacation";

      return (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`leave-tooltip-${arg.event.id}`}>
              {icon} {label} ({translatedStatus})
            </Tooltip>
          }
        >
          <div
            className={`d-inline-flex px-2 align-items-center gap-1 rounded w-100 overflow-hidden leave-pill cursor-pointer ${pillBg} ${pillBorder}`}
            style={!isSick && !isApprovedVacation ? { backgroundColor: "rgba(255, 193, 7, 0.18)" } : {}}
          >
            <span className="fs-12">{icon}</span>
            <span className={`fs-12 fw-medium ${pillText}`}>{label}</span>
            <span className={`fs-12 fw-normal opacity-75 ${pillText}`}></span>
          </div>
        </OverlayTrigger>
      );
    }

    if (isClientView && !isEmployeeView) {
      const orderId = arg.event.extendedProps?.orderId;
      const eventDate = moment(arg.event.start).format("YYYY-MM-DD");
      const currentCleanerId = arg.event.extendedProps?.rawData?.CleanerId;

      const allOrderDayEvents = initialEvents.filter(
        (e) =>
          e.extendedProps?.orderId === orderId &&
          !e.extendedProps?.isLeave &&
          moment(e.start).format("YYYY-MM-DD") === eventDate &&
          (isEmployeeViewToggle
            ? e.extendedProps?.rawData?.CleanerId === currentCleanerId
            : true)
      );
      const firstEventId = allOrderDayEvents[0]?.id;
      const isInPopover = arg.isPast === undefined ? false :
        document.querySelector(".fc-popover") != null &&
        arg.event.extendedProps?._forceShow === true;

      const isMonthClientView = viewType === "dayGridMonth" && !isEmployeeViewToggle;
      if (!isMonthClientView && arg.event.id !== firstEventId && !isInPopover) {
        return null;
      }

      const orderEvents = initialEvents.filter(
        (e) =>
          e.extendedProps?.orderId === orderId &&
          !e.extendedProps?.isLeave &&
          moment(e.start).format("YYYY-MM-DD") === eventDate
      );

      const assignedEmployees = [
        ...new Set(orderEvents.map((e) => e.extendedProps?.rawData?.CleanerId).filter(Boolean))
      ];
      const requiredEmployees = assignedEmployees.length;   
      const conflictEmployees = assignedEmployees.filter(
        (empId) => conflictMap[empId]?.dates?.has(eventDate)
      );
      const missingEmployees = conflictEmployees.length; 
      const availableEmployees = requiredEmployees - missingEmployees; 
      const totalEmployees = requiredEmployees;  
      const isAttentionNeeded = missingEmployees > 0;
      const orderStatus = allOrderDayEvents[0]?.extendedProps?.rawData?.OrderStatus;
      const statusColorClass = getOrderStatusColorClass(orderStatus);
      const borderColorMap = {
        "bg-primary-subtle": "border-primary",
        "bg-info-subtle": "border-info",
        "bg-success-subtle": "border-success",
        "bg-warning-subtle": "border-warning",
        "bg-danger-subtle": "border-danger",
      };
      const statusBorderClass = borderColorMap[statusColorClass] || "border-secondary";
      const borderClass = isAttentionNeeded
        ? "border-danger bg-danger-subtle"
        : `${statusColorClass} ${statusBorderClass}`;

      const cardBgBorderClass = isAttentionNeeded
        ? "border-danger bg-danger-subtle text-danger"
        : (() => {
          const s = (orderStatus || "draft").toLowerCase();
          if (s === "completed" || s === "2") return "border-success bg-success-subtle text-success";
          if (s === "active" || s === "1") return "border-success bg-success-subtle text-success";
          if (s === "draft" || s === "0") return "border-primary bg-primary-subtle text-primary";
          return "border-primary bg-primary-soft text-primary";
        })();

      const raw = data?.rawData;

      const taskDate = moment(raw?.WeekStartDate)
        .isoWeekday(raw?.DayOfWeek)
        .format("YYYY-MM-DD");

      const startTime = raw?.OrderStartTime || raw?.StartTime;
      const endTime = raw?.OrderEndTime || raw?.EndTime;

      const getDateTime = (date, time) => {
        if (!time) return null;
        const timeOnly = moment.utc(time).format("HH:mm:ss");
        return moment.utc(`${date}T${timeOnly}`).local();
      };

      const startMoment = getDateTime(taskDate, startTime);
      const endMoment = getDateTime(taskDate, endTime);

      const timeLabel = data.hasExplicitEndTime && endMoment
        ? `${startMoment?.format("HH:mm")} - ${endMoment?.format("HH:mm")}`
        : startMoment?.format("HH:mm");

      if (viewType === "dayGridMonth") {
        return (
          <div className={`border-start border-2 bg-opacity-25 ${cardBgBorderClass} rounded-1 px-1 w-100 overflow-hidden calendar-event-inner`}>
            <div className="d-flex align-items-center gap-1 w-100" style={{ minWidth: 0 }}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`month-status-${arg.event.id}`}>
                    {isAttentionNeeded ? (
                      <div>
                        <div>{t("attention")} ({missingEmployees}/{totalEmployees})</div>
                        <div className="text-white mt-1 font-size-11">
                          {t("clickToSeeConflicts")}
                        </div>
                      </div>
                    ) : (
                      (() => {
                        const s = String(orderStatus ?? "").toLowerCase();
                        if (s === "2" || s === "completed") return t("completed");
                        if (s === "1" || s === "active") return t("active");
                        if (s === "3" || s === "cancelled") return t("cancelled");
                        return t("draft");
                      })()
                    )}
                  </Tooltip>
                }
              >
                <span className={`dot-indicator flex-shrink-0 rounded-circle 
                  ${isAttentionNeeded ? "bg-danger cursor-pointer" : "cursor-default"}
                  ${!isAttentionNeeded
                    ? (() => {
                      const s = String(orderStatus ?? "").toLowerCase();
                      if (s === "2" || s === "completed") return "bg-success";
                      if (s === "1" || s === "active") return "bg-success";
                      if (s === "0" || s === "draft") return "bg-primary";
                      if (s === "3" || s === "cancelled") return "bg-danger";
                      return "bg-primary";
                    })()
                    : ""
                  }`}
                  onClick={(e) => {
                    if (!isAttentionNeeded) return;
                    e.stopPropagation();
                    const raw = data?.rawData;
                    if (!raw?.OrderId) return;

                    setInitialEvents([]);
                    setResourceList([]);
                    setSelectedOrderId(raw.OrderId);
                    setSelectedOrderClient(data.clientName);
                    setSelectedDropdownOrderId(raw.OrderId);
                    setSelectedClientPlanning(raw.RelationId);

                    lastFetchKeyRef.current = null;
                    fetchInProgressRef.current = false;

                    const api = calendarRef.current?.getApi();
                    if (api) {
                      api.changeView("resourceTimelineWeek");
                      api.gotoDate(arg.event.start);
                    }

                    setTimeout(() => {
                      const freshApi = calendarRef.current?.getApi();
                      if (freshApi?.view) {
                        const start = moment(freshApi.view.currentStart).toDate();
                        const end = moment(freshApi.view.currentEnd)
                          .subtract(1, "day")
                          .toDate();
                        fetchCalendarData(start, end, false, "drilldown");
                      }
                    }, 100);
                  }}
                />
              </OverlayTrigger>
              <span className={`fw-semibold text-truncate flex-grow-1 ${cardBgBorderClass}`}>
                {data.rawData?.TemplateName}
              </span>
              <span className="text-muted text-500 flex-shrink-0 calendar-event-time">
                {moment(arg.event.start).format("HH:mm")}
              </span>
            </div>
            <div className="text-muted text-500 text-truncate calendar-event-time calendar-event-subtitle">
              {data.clientName || data.rawData?.Relation?.Name}
            </div>
          </div>
        );
      }

      // ── WEEK / DAY VIEW: full card ───────────────────────────────────────
      return (
        <div className={`position-relative border-start border-3 bg-opacity-25 ${cardBgBorderClass} rounded-2 px-2 py-2`}>
          <div className="d-flex flex-column mb-1 w-100 overflow-hidden">
            <div className="d-flex align-items-center justify-content-between gap-1">
              <div className="fw-semibold text-dark fs-12 text-truncate flex-grow-1">
                {data.rawData?.TemplateName}
              </div>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`drilldown-${arg.event.id}`}>{t("viewAssignedEmployees")}</Tooltip>}
              >
                <span
                  className="flex-shrink-0 cursor-pointer text-secondary lh-1 z-3"
                  onClick={(e) => {
                    e.stopPropagation();
                    const raw = data?.rawData;
                    if (!raw?.OrderId) return;
                    setInitialEvents([]);
                    setResourceList([]);
                    setSelectedOrderId(raw.OrderId);
                    setSelectedOrderClient(data.clientName);
                    setSelectedDropdownOrderId(raw.OrderId);
                    setSelectedClientPlanning(raw.RelationId);
                    lastFetchKeyRef.current = null;
                    fetchInProgressRef.current = false;
                    const api = calendarRef.current?.getApi();
                    if (api?.view) {
                      const start = moment(api.view.activeStart).toDate();
                      const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
                      fetchCalendarData(start, end, false, "drilldown");
                    }
                  }}
                >
                  <FontAwesomeIcon icon="external-link-alt" className="fs-11" />
                </span>
              </OverlayTrigger>
            </div>

            <div className="w-100">
              {isAttentionNeeded ? (
                <span className="badge fs-14 mt-1 rounded-pill d-inline-block mw-100 text-truncate bg-danger-subtle text-danger border border-danger border-opacity-10">
                  {t("attention")}
                </span>
              ) : (() => {
                const orderStatusText = (orderStatus).toLowerCase();
                const subtleClass =
                  orderStatusText === "active" ? "bg-success-subtle text-success border border-success border-opacity-10" :
                    orderStatusText === "completed" ? "bg-success-subtle text-success border border-success border-opacity-10" :
                      "bg-primary-subtle text-primary border border-primary border-opacity-10";
                return (
                  <span className={`badge fs-14 mt-1 rounded-pill d-inline-block mw-100 text-truncate ${subtleClass}`}>
                    {t(orderStatusText)}
                  </span>
                );
              })()}
            </div>
          </div>

          {isAttentionNeeded && (<div className="text-danger fs-11 mb-1"> {t("missingEmployees", { count: availableEmployees, total: requiredEmployees })} </div>)}
          <div className="text-muted fs-11 mb-1 d-flex align-items-start gap-1">
            <i className="fas fa-map-marker-alt text-500 flex-shrink-0 calendar-event-time calendar-icon"></i>
            <span className="flex-grow-1 text-break calendar-event-location">
              {[data.rawData?.Relation?.StreetName, data.rawData?.Relation?.City]
                .filter((val) => val && val.toString().trim() !== "")
                .join(", ")}
            </span>
          </div>
          <div className="text-muted fs-11 mb-1 d-flex align-items-start gap-1">
            <i className="fas fa-clock text-500 flex-shrink-0 calendar-event-time calendar-icon"></i>
            <span className="text-dark text-nowrap">{timeLabel}</span>
          </div>
        </div>
      );
    }

    // ─────────────────────────────────────────────────────────────────────────
    // EMPLOYEE / DRILLDOWN VIEW — 3rd block
    // ─────────────────────────────────────────────────────────────────────────
    const [taskName = "", cleanerName = ""] = (arg.event.title || "").split(" - ");
    const status = arg.event.extendedProps?.rawData?.Status;
    const raw = data?.rawData;

    const actualStartTime = raw?.ActualStartTime;
    const rawStartTime = raw?.StartTime;

    const isResourceView =
      viewType === "resourceTimelineWeek" || viewType === "resourceTimelineDay";

    let startedLate = false;
    if (rawStartTime && actualStartTime && raw?.ActualStartDate) {
      const taskDate = moment(raw?.WeekStartDate).isoWeekday(raw?.DayOfWeek).format("YYYY-MM-DD");

      const scheduledHHMM = moment.utc(rawStartTime).local().format("HH:mm");
      const scheduled = moment(`${taskDate} ${scheduledHHMM}`, "YYYY-MM-DD HH:mm");

      const actualHHMM = moment.utc(actualStartTime).local().format("HH:mm");
      const actual = moment(`${raw.ActualStartDate} ${actualHHMM}`, "YYYY-MM-DD HH:mm");

      startedLate = actual.isAfter(scheduled);
    }

    const isCompleted =
      status?.toLowerCase?.() === "completed" ||
      status === "2" ||
      !!raw?.ActualEndTime;

    if (isResourceView) {
      const taskDate = moment(raw?.WeekStartDate)
        .isoWeekday(raw?.DayOfWeek)
        .format("YYYY-MM-DD");

      const getDateTime = (date, time) => {
        if (!time) return null;
        const timeOnly = moment.utc(time).format("HH:mm:ss");
        return moment.utc(`${date}T${timeOnly}`).local();
      };

      const startMoment = getDateTime(taskDate, raw?.StartTime);
      const endMoment = getDateTime(taskDate, raw?.EndTime);

      const startDisplay = startMoment?.format("HH:mm") || moment(arg.event.start).format("HH:mm");
      const endDisplay = endMoment?.format("HH:mm") || moment(arg.event.end).format("HH:mm");
      const durationMins = startMoment && endMoment
        ? endMoment.diff(startMoment, "minutes")
        : raw?.DurationMinutes || 0;
      const durationLabel = durationMins > 0 ? ` (${formatDurationLocalized(durationMins)})` : "";
      const timeLabel = `${startDisplay} - ${endDisplay}${durationLabel}`;

      // ── Use order detail Status (raw?.Status) ──
      const detailStatus = String(raw?.Status ?? "0").toLowerCase();

      // FIX 2: statusLabel — direct translation keys, no broken t("orderDetailStatus.X")
      const statusLabel = (() => {
        if (detailStatus === "2" || detailStatus === "jobcomplete" || detailStatus === "completed") return t("completed");
        if (detailStatus === "1" || detailStatus === "inprogress" || detailStatus === "active") return t("active");
        if (detailStatus === "6" || detailStatus === "cancelled") return t("cancelled");
        if (detailStatus === "7" || detailStatus === "incomplete") return t("incomplete");
        return t("planned");
      })();

      // FIX 1: removed bg-opacity-25 from cardBgBorderClass
      const cardBgBorderClass = (() => {
        if (detailStatus === "2" || detailStatus === "jobcomplete" || detailStatus === "completed") return "border-success bg-success-subtle text-success";
        if (detailStatus === "1" || detailStatus === "inprogress" || detailStatus === "active") return "border-success bg-success-subtle text-success";
        if (detailStatus === "6" || detailStatus === "cancelled") return "border-danger bg-danger-subtle text-danger";
        if (detailStatus === "7" || detailStatus === "incomplete") return "border-warning bg-warning-subtle text-warning";
        return "border-primary bg-primary-subtle text-primary";
      })();

      const subtleClass = (() => {
        if (detailStatus === "2" || detailStatus === "jobcomplete" || detailStatus === "completed") return "bg-success-subtle text-success border border-success border-opacity-10";
        if (detailStatus === "1" || detailStatus === "inprogress" || detailStatus === "active") return "bg-success-subtle text-success border border-success border-opacity-10";
        if (detailStatus === "6" || detailStatus === "cancelled") return "bg-danger-subtle text-danger border border-danger border-opacity-10";
        if (detailStatus === "7" || detailStatus === "incomplete") return "bg-warning-subtle text-warning border border-warning border-opacity-10";
        return "bg-primary-subtle text-primary border border-primary border-opacity-10";
      })();

      const isDayView = viewType === "resourceTimelineDay";
      return (
        // FIX 1: removed bg-opacity-25 here — subtle bg classes already have correct opacity
        <div className={`position-relative border-start border-3 ${cardBgBorderClass} rounded-2 px-2 py-2 ${isDayView ? "overflow-hidden" : ""}`}>

          {/* Remove button: absolutely positioned top-right, visible on hover */}
          {!isCompleted && showHoursHeader && !isReadOnly && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`remove-tooltip-${arg.event.id}`}>{t("removeEmployee")}</Tooltip>}
            >
              <span
                className="remove-employee-btn cursor-pointer text-danger lh-1 position-top-right-3 z-3"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedOrderDetailId(arg.event.id);
                  setSelectedEmployeeId(raw?.CleanerId);
                  setSelectedTaskDate(moment(arg.event.start).format("YYYY-MM-DD"));
                  setShowCleanerDeleteModal(true);
                }}
              >
                <i className="fas fa-times-circle fs-11" />
              </span>
            </OverlayTrigger>
          )}

          {/* Row 1: exclamation icon + Client name */}
          <div className="d-flex align-items-center gap-1 mb-1">
            {startedLate && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`late-tooltip-${arg.event.id}`}>{t("jobStartedLate")}</Tooltip>}
              >
                <FontAwesomeIcon
                  icon={faExclamationCircle}
                  className="text-warning cursor-pointer flex-shrink-0"
                  style={{ fontSize: "11px" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    toast.warning(t("jobStartedLate"), { position: "top-right" });
                  }}
                />
              </OverlayTrigger>
            )}
            <div className={`fw-semibold text-dark fs-12 flex-grow-1 calendar-event-title-wrap ${isDayView ? "text-truncate" : ""}`}>
              {userRole === USER_ROLES.CLIENT
                ? (raw?.TaskName || taskName || raw?.TemplateName)
                : (raw?.Relation?.Name || data?.clientName || cleanerName)}
            </div>
          </div>

          {/* Row 2: Task detail status badge */}
          <div className="mb-1">
            <span className={`badge fs-14 rounded-pill d-inline-block mw-100 text-truncate ${subtleClass}`}>
              {statusLabel}
            </span>
          </div>

          {/* Row 3: Location */}
          {userRole !== USER_ROLES.CLIENT && (
            <div className="text-muted fs-11 mb-1 d-flex align-items-start gap-1">
              <i className="fas fa-map-marker-alt text-500 flex-shrink-0 calendar-icon"></i>
              <span className={`flex-grow-1 calendar-event-location ${isDayView ? "text-truncate d-block" : "text-break"}`}>
                {[raw?.Relation?.StreetName, raw?.Relation?.City]
                  .filter((val) => val && val.toString().trim() !== "")
                  .join(", ")}
              </span>
            </div>
          )}

          {/* Row 4: Start - End (total duration) */}
          <div className="text-muted fs-11 d-flex align-items-start gap-1">
              <i className="fas fa-clock text-500 flex-shrink-0 calendar-icon"></i>
              <div className={`d-flex flex-column ${isDayView ? "overflow-hidden" : ""}`}>
                  <span className={`text-dark text-nowrap ${isDayView ? "text-truncate" : ""}`}>{startDisplay} - {endDisplay}</span>
                  {durationMins > 0 && (
                      <span className={`text-muted ${isDayView ? "text-truncate" : ""}`}>({formatDurationLocalized(durationMins)})</span>
                  )}
              </div>
          </div>
        </div>
      );
    }

    // ── Fallback: dayGridMonth / timeGridWeek ─────────────────────────────
    const eventStartTime = arg.event.start
      ? moment(arg.event.start).format("HH:mm")
      : "";

    const detailStatusFallback = String(raw?.Status ?? "0").toLowerCase();
    const fallbackTextClass = (() => {
      if (detailStatusFallback === "2" || detailStatusFallback === "jobcomplete" || detailStatusFallback === "completed") return "text-success";
      if (detailStatusFallback === "1" || detailStatusFallback === "inprogress" || detailStatusFallback === "active") return "text-success";
      if (detailStatusFallback === "6" || detailStatusFallback === "cancelled") return "text-danger";
      if (detailStatusFallback === "7" || detailStatusFallback === "incomplete") return "text-warning";
      return "text-primary";
    })();

    const fallbackBorderClass = (() => {
      if (detailStatusFallback === "2" || detailStatusFallback === "jobcomplete" || detailStatusFallback === "completed") return "border-success";
      if (detailStatusFallback === "1" || detailStatusFallback === "inprogress" || detailStatusFallback === "active") return "border-success";
      if (detailStatusFallback === "6" || detailStatusFallback === "cancelled") return "border-danger";
      if (detailStatusFallback === "7" || detailStatusFallback === "incomplete") return "border-warning";
      return "border-primary";
    })();

    return (
      <div className={`border-start border-2 ${fallbackBorderClass} ${detailStatusFallback === "2" || detailStatusFallback === "jobcomplete" || detailStatusFallback === "completed" ? "bg-success-subtle" :
        detailStatusFallback === "1" || detailStatusFallback === "inprogress" || detailStatusFallback === "active" ? "bg-success-subtle" :
          detailStatusFallback === "6" || detailStatusFallback === "cancelled" ? "bg-danger-subtle" :
            detailStatusFallback === "7" || detailStatusFallback === "incomplete" ? "bg-warning-subtle" :
              "bg-primary-subtle"
        } rounded-1 px-1 w-100 overflow-hidden calendar-event-inner`}>
        <div className="d-flex align-items-center gap-1 w-100" style={{ minWidth: 0 }}>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`status-tooltip-${arg.event.id}`}>
                {(() => {
                  if (
                    detailStatusFallback === "2" ||
                    detailStatusFallback === "jobcomplete" ||
                    detailStatusFallback === "completed"
                  ) return t("completed");

                  if (
                    detailStatusFallback === "1" ||
                    detailStatusFallback === "inprogress" ||
                    detailStatusFallback === "active"
                  ) return t("active");

                  if (
                    detailStatusFallback === "6" ||
                    detailStatusFallback === "cancelled"
                  ) return t("cancelled");

                  if (
                    detailStatusFallback === "7" ||
                    detailStatusFallback === "incomplete"
                  ) return t("incomplete");

                  return t("planned");
                })()}
              </Tooltip>
            }
          >
            <span
              className={`dot-indicator flex-shrink-0 rounded-circle
      ${detailStatusFallback === "2" ||
                  detailStatusFallback === "jobcomplete" ||
                  detailStatusFallback === "completed"
                  ? "bg-success"
                  : detailStatusFallback === "1" ||
                    detailStatusFallback === "inprogress" ||
                    detailStatusFallback === "active"
                    ? "bg-success"
                    : detailStatusFallback === "6" ||
                      detailStatusFallback === "cancelled"
                      ? "bg-danger"
                      : detailStatusFallback === "7" ||
                        detailStatusFallback === "incomplete"
                        ? "bg-warning"
                        : "bg-primary"
                }`}
            />
          </OverlayTrigger>
          <span className={`fw-semibold text-truncate flex-grow-1 ${fallbackTextClass}`}>
            {raw?.Relation?.Name || data?.clientName || cleanerName}
          </span>
          <span className="text-muted text-500 flex-shrink-0 calendar-event-time">
            {eventStartTime}
          </span>
        </div>
        <div className="text-muted text-500 text-truncate calendar-event-time calendar-event-subtitle">
          {raw?.TemplateName || taskName}
        </div>
      </div>
    );
  };

  const getColorFromName = (name) => {
    const colors = [
      "bg-primary-subtle text-primary-emphasis",
      "bg-success-subtle text-success-emphasis",
      "bg-warning-subtle text-warning-emphasis",
      "bg-danger-subtle text-danger-emphasis",
      "bg-info-subtle text-info-emphasis",
    ];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
  };

  useEffect(() => {
    const api = calendarRef.current?.getApi();
    if (!api) return;

    const shouldExpand =
      selectedOrderId ||
      (selectedClientPlanning && selectedClientPlanning !== "all") ||
      selectedEmployee ||
      expandAllTasks;

    api.setOption("eventMaxStack", shouldExpand ? 999 : 1);

  }, [selectedOrderId, selectedClientPlanning, selectedEmployee, expandAllTasks]);

  useEffect(() => {
    const api = calendarRef.current?.getApi();
    if (!api) return;

    const shouldExpand =
      selectedOrderId ||
      (selectedClientPlanning && selectedClientPlanning !== "all");

    api.setOption("dayMaxEvents", shouldExpand ? false : 2);

  }, [selectedOrderId, selectedClientPlanning]);

  const getStatusColorClass = (status) => {
    const statusNumberToKey = {
      0: "planned",
      1: "inprogress",
      2: "jobcomplete",
      3: "unabletoaccesslocation",
      4: "customernotavailable",
      5: "equipmentissue",
      6: "cancelledbycustomer",
      7: "incomplete",
    };

    let normalizedStatus = "";
    if (status === null || status === undefined) {
      normalizedStatus = "";
    } else if (!isNaN(Number(status))) {
      normalizedStatus = statusNumberToKey[Number(status)] || "";
    } else {
      normalizedStatus = status.toString().replace(/\s+/g, "").toLowerCase();
    }

    const classMap = {
      planned: "bg-primary-subtle",
      inprogress: "bg-success-subtle",
      jobcomplete: "bg-success-subtle",
      unabletoaccesslocation: "bg-warning-subtle",
      customernotavailable: "bg-warning-subtle",
      equipmentissue: "bg-warning-subtle",
      cancelledbycustomer: "bg-danger-subtle",
      incomplete: "bg-warning-subtle",
    };

    return classMap[normalizedStatus] || "bg-warning-subtle";
  };

  const getOrderStatusColorClass = (orderStatus) => {
    if (!orderStatus) return "bg-primary-subtle";
    const s = orderStatus.toString().toLowerCase();
    if (s === "draft" || s === "0") return "bg-primary-subtle";
    if (s === "active" || s === "1") return "bg-success-subtle";
    if (s === "completed" || s === "2") return "bg-success-subtle";
    if (s === "cancelled" || s === "3") return "bg-danger-subtle";
    return "bg-primary-subtle";
  };

  const handleEventClick = (info) => {
    document
      .querySelectorAll(".tooltip.show")
      .forEach((el) => el.classList.remove("show"));

    if (info.event.extendedProps?.isLeave && info.event.extendedProps?.isLeaveBadge) {
      const leave = info.event.extendedProps?.leaveRawData;
      if (leave) {
        const employee = employeeList.find(
          (emp) => emp.UserId === (leave.UserId || leave.userId)
        );

        setSelectedLeaveData({
          UnavailabilityId: leave.UnavailabilityId || leave.unavailabilityId,
          Type: leave.Type || leave.type,
          Status: leave.Status || leave.status,
          StartDate: leave.StartDate || leave.startDate,
          EndDate: leave.EndDate || leave.endDate,
          StartTime: leave.StartTime || leave.startTime,
          EndTime: leave.EndTime || leave.endTime,
          Notes: leave.Notes || leave.notes,
          AdminNote: leave.AdminNote || leave.adminNote,
          userName: employee?.Name || '--',
          userRole: employee?.roleDetails?.Name || employee?.Role || '--',
          avatarColor: 'bg-primary-subtle text-primary-emphasis',
          decisionByName: leave.decisionByName || leave.DecisionByName,
          updatedAt: leave.updatedAt || leave.UpdatedAt,
          UserId: leave.UserId || leave.userId,
          RequestGroupId: leave.RequestGroupId || leave.requestGroupId,
          CustomerId: leave.CustomerId || leave.customerId || localStorage.getItem('customerId'),
        });
        setLeaveDrawerOpen(true);

      }
      return;
    }

    const data = info.event.extendedProps;
    const raw = data?.rawData;
    if (!selectedOrderId && raw?.OrderId && !isEmployeeViewToggle) {
      const clickedDate = moment(info.event.start).format('YYYY-MM-DD');
      const orderId = raw.OrderId;
      const dayEvents = initialEvents.filter(
        (e) =>
          e.extendedProps?.orderId === orderId &&
          !e.extendedProps?.isLeave &&
          moment(e.start).format('YYYY-MM-DD') === clickedDate
      );
      setSelectedOrderDayEvents(dayEvents);  
      const allOrderEvents = initialEvents.filter(
        (e) => e.extendedProps?.orderId === orderId && !e.extendedProps?.isLeave
      );
      const orderStartDate = allOrderEvents.reduce((min, e) =>
        moment(e.start).isBefore(min) ? moment(e.start) : min,
        moment(allOrderEvents[0]?.start)
      );
      const orderEndDate = allOrderEvents.reduce((max, e) =>
        moment(e.end).isAfter(max) ? moment(e.end) : max,
        moment(allOrderEvents[0]?.end)
      );
      setSelectedOrderEventData({
        ...data,
        orderStartDate: raw?.OrderStartDate,
        orderEndDate: raw?.OrderEndDate,
        orderStartTime: raw?.OrderStartTime,
        orderEndTime: raw?.OrderEndTime,
      });

      setOrderDrawerOpen(true);
      return;
    }

    if (raw) {
      clickedSubtasksRef.current = new Set();
      openTaskDrawerForEvent(raw);
    }
  };

  const getEmployeeLeaveOnDate = (employeeId, date) => {
    const dateStr = moment(date).format("YYYY-MM-DD");
    return initialEvents.find((e) => {
      if (!e.extendedProps?.isLeaveBadge) return false;
      if (e.resourceId !== employeeId) return false;
      const leaveStart = moment(e.start).format("YYYY-MM-DD");
      const leaveEnd = moment(e.end).subtract(1, "day").format("YYYY-MM-DD");
      return moment(dateStr).isBetween(leaveStart, leaveEnd, "day", "[]");
    });
  };

  const handleEventDrop = async (info) => {
    const { event } = info;
    if (event.extendedProps?.isLeaveBadge) {
      const leave = event.extendedProps?.leaveRawData;
      const newEmployeeId = info.newResource?.id;
      const isSameEmployee = !newEmployeeId || newEmployeeId === leave?.UserId;
      const effectiveEmployeeId = isSameEmployee ? leave?.UserId : newEmployeeId;
      const oldStartDate = moment(leave.StartDate).format("YYYY-MM-DD");
      const newStartDate = moment(event.start).format("YYYY-MM-DD");
      const isDateChanged = oldStartDate !== newStartDate;

      if (isSameEmployee && !isDateChanged) {
        info.revert();
        return;
      }

      const oldEmployee = allEmployees.find(e => e.UserId === leave?.UserId);
      const newEmpObj = allEmployees.find(e => e.UserId === newEmployeeId);
      const leaveTypeLabel = leave.Type === "sickness" ? t("sickLeave") : t("vacation");

      setPendingLeaveReassignInfo({
        info,
        leave,
        effectiveEmployeeId,
        isSameEmployee,
        oldEmployeeName: oldEmployee?.Name || t("anotherEmployee"),
        newEmployeeName: isSameEmployee ? oldEmployee?.Name : (newEmpObj?.Name || t("anotherEmployee")),
        leaveType: leaveTypeLabel,
        newStartDate: moment(event.start).format("YYYY-MM-DD"),
        newEndDate: moment(event.end).subtract(1, "day").format("YYYY-MM-DD"),
        startTime: leave.StartTime ? moment(leave.StartTime).format("HH:mm") : null,
        endTime: leave.EndTime ? moment(leave.EndTime).format("HH:mm") : null,
      });
      setShowLeaveReassignModal(true);
      return;
    }

    const raw = event.extendedProps?.rawData;
    if (!raw?.OrderDetailId) return;

    if (raw.Status === "2" || raw.ActualEndTime) {
      toast.error(t("cannotReassignCompletedJob"), { position: "top-right" });
      info.revert();
      return;
    }

    const newStart = moment(event.start);
    const newEnd = moment(event.end);
    const emailDate = newStart.format("YYYY-MM-DD");
    const emailStartTime = newStart.format("HH:mm");
    const emailEndTime = newEnd.format("HH:mm");
    const newCleanerId = info.newResource?.id || null;
    const oldCleanerId = raw.CleanerId;
    const isEmployeeChanged = newCleanerId && newCleanerId !== oldCleanerId;
    const targetEmployeeId = newCleanerId || raw.CleanerId;

    if (skipAllChecksRef.current) {
      skipAllChecksRef.current = false;
      skipPastCheckRef.current = false;
      skipTaskConflictCheckRef.current = false;
    } else {
      const issues = [];
      const employeeNameForChecks =
        resourceList.find((r) => r.id === targetEmployeeId)?.title ||
        allEmployees.find((e) => e.UserId === targetEmployeeId)?.Name ||
        targetEmployeeId;

    const leaveOnDropDate = getEmployeeLeaveOnDate(targetEmployeeId, event.start);
      if (leaveOnDropDate) {
        issues.push({
          type: "leave",
          employeeId: targetEmployeeId,
          employeeName: employeeNameForChecks,
          leaveType: leaveOnDropDate.extendedProps?.leaveType,
          leaveStatus: leaveOnDropDate.extendedProps?.leaveStatus,
        });
      }

      const inViewSlots = initialEvents
        .filter((e) => !e.extendedProps?.isLeave && e.id !== raw.OrderDetailId)
        .map((e) => ({
          id: e.id,
          employeeId: e.extendedProps?.rawData?.CleanerId,
          start: e.start,
          end: e.end,
          label: e.extendedProps?.rawData?.TaskName || e.extendedProps?.rawData?.TemplateName,
          clientName: e.extendedProps?.rawData?.Relation?.Name || e.extendedProps?.clientName,
          dayKey: moment(e.start).format("dddd").toLowerCase(),
          date: moment(e.start).format("YYYY-MM-DD"),
        }));

      const startTimeOfDay = moment(newStart);
      const endTimeOfDay = moment(newEnd);

      const taskConflictResult = await checkEmployeeAvailability({
        employeeId: targetEmployeeId,
        conflictMap: {},
        startDate: newStart.format("YYYY-MM-DD"),
        endDate: newStart.format("YYYY-MM-DD"),
        occurrenceDates: [moment(newStart)],
        timeWindow: { startTimeOfDay, endTimeOfDay },
        inFormSlots: inViewSlots,
        customerId: localStorage.getItem("customerId"),
        excludeOrderDetailId: raw.OrderDetailId,
      });

      if (taskConflictResult?.type === "taskConflict") {
        issues.push({
          type: "taskConflict",
          employeeId: targetEmployeeId,
          employeeName: employeeNameForChecks,
          conflictTaskName: taskConflictResult.conflictTaskName,
          conflictClientName: taskConflictResult.conflictClientName,
          conflictStart: taskConflictResult.conflictStart,
          conflictEnd: taskConflictResult.conflictEnd,
        });
      }

      if (moment(event.start).isBefore(moment(), "day")) {
        const fromEmployee = allEmployees.find((e) => e.UserId === oldCleanerId)?.Name ||
          resourceList.find((r) => r.id === oldCleanerId)?.title ||
          oldCleanerId;
        const toEmployee = newCleanerId
          ? allEmployees.find((e) => e.UserId === newCleanerId)?.Name ||
            resourceList.find((r) => r.id === newCleanerId)?.title ||
            newCleanerId
          : null;
        issues.push({
          type: "pastDateAssign",
          employeeId: targetEmployeeId,
          employeeName: employeeNameForChecks,
          fromEmployee,
          toEmployee,
        });
      }

      if (issues.length >= 1) {
        setPendingCombinedDropInfo({ info, issues });
        setShowCombinedWarningModal(true);
        return;
      }
    }
    skipPastCheckRef.current = false;
    skipTaskConflictCheckRef.current = false;
    const durationHours = (new Date(event.end) - new Date(event.start)) / (1000 * 60 * 60);

    setInitialEvents((prev) =>
      prev.map((e) => {
        if (e.id !== raw.OrderDetailId) return e;
        return {
          ...e,
          start: newStart.toISOString(),
          end: newEnd.toISOString(),
          resourceId: isEmployeeChanged ? newCleanerId : e.resourceId,
          extendedProps: {
            ...e.extendedProps,
            rawData: {
              ...e.extendedProps.rawData,
              ...(isEmployeeChanged && { CleanerId: newCleanerId }),
              WeekStartDate: newStart.format("YYYY-MM-DD"),
              DayOfWeek: newStart.format("dddd").toLowerCase(),
            },
          },
        };
      })
    );

    if (isEmployeeChanged) {
      setResourceList((prev) =>
        prev.map((r) => {
          if (r.id === oldCleanerId) {
            return { ...r, extendedProps: { ...r.extendedProps, workedHours: Math.max(0, (r.extendedProps?.workedHours || 0) - durationHours) } };
          }
          if (r.id === newCleanerId) {
            return { ...r, extendedProps: { ...r.extendedProps, workedHours: (r.extendedProps?.workedHours || 0) + durationHours } };
          }
          return r;
        })
      );
    }

    const updates = {
      WeekStartDate: newStart.format("YYYY-MM-DD"),
      DayOfWeek: newStart.format("dddd").toLowerCase(),
      StartTime: newStart ? newStart.utc().set({ year: 1970, month: 0, date: 1 }).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
      EndTime: newEnd ? newEnd.utc().set({ year: 1970, month: 0, date: 1 }).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]") : null,
      ...(isEmployeeChanged && { CleanerId: newCleanerId }),
    };

    try {
      await axios.patch(
        `${process.env.REACT_APP_API_URL}/orderRoute/updateOrderDetail`,
        {
          orderDetailId: raw.OrderDetailId,
          updates,
          performedBy: localStorage.getItem("UserId"),
        },
        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
      );
      toast.success(t("taskDetailsUpdatedSuccessfully"), { position: "top-right" });

      // ── Notifications ──────────────────────────────────────────────────────
      if (!isEmployeeChanged) {
        (async () => {
          try {
            const customerId = localStorage.getItem("customerId");
            const userId = localStorage.getItem("UserId");
            const culture = localStorage.getItem("culture") || "nl";

            const frequency = await fetchFrequencyLabel(raw.ProposalId, raw.ProposalTaskId, t);
            const location = [raw.Relation?.StreetName, raw.Relation?.PostCode, raw.Relation?.City].filter(Boolean).join(", ");
            const cleaner = allEmployees.find(e => e.UserId === raw.CleanerId);
            if (!cleaner) return;

            const entry = buildTaskNotificationEntry({
              cleaner: { userId: raw.CleanerId, name: cleaner.Name, email: cleaner.Emailaddress, phone: cleaner.PhoneNumber },
              taskName: raw.TaskName,
              clientName: raw.Relation?.Name,
              location,
              date: emailDate,
              startTime: emailStartTime,
              endTime: emailEndTime,
              frequency,
              culture,
              organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
              userId,
              sourceId: raw.OrderId,
              isActionRequired: true,
              inAppMessageCleanerKey: "in-AppNotifications.taskRescheduledMessage",
              inAppMessageCleanerParams: { taskName: raw.TaskName, clientName: raw.Relation?.Name, date: emailDate, startTime: emailStartTime, endTime: emailEndTime },
              inAppManagerSuffixKey: "in-AppNotifications.orderRescheduledManagerSuffix",
              inAppManagerSuffixParams: { clientName: raw.Relation?.Name },
              t,
            });

            await dispatchBatchNotification({ customerId, eventKey: "TASK_UPDATED", entries: [entry] });
          } catch (err) {
            console.error("[DROP] Reschedule notification error (non-blocking):", err);
          }
        })();
      }

      if (isEmployeeChanged) {
        (async () => {
          try {
            const customerId = localStorage.getItem("customerId");
            const userId = localStorage.getItem("UserId");
            const culture = localStorage.getItem("culture") || "nl";

            const frequency = await fetchFrequencyLabel(raw.ProposalId, raw.ProposalTaskId, t);
            const location = [raw.Relation?.StreetName, raw.Relation?.PostCode, raw.Relation?.City].filter(Boolean).join(", ");

            const oldCleaner = allEmployees.find(e => e.UserId === oldCleanerId);
            const newCleaner = allEmployees.find(e => e.UserId === newCleanerId);
            if (!newCleaner) return;

            const baseParams = {
              taskName: raw.TaskName,
              clientName: raw.Relation?.Name,
              location,
              date: emailDate,
              startTime: emailStartTime,
              endTime: emailEndTime,
              frequency,
              culture,
              organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
              userId,
              sourceId: raw.OrderId,
              t,
            };

            if (oldCleaner) {
              const unassignEntry = buildTaskNotificationEntry({
                ...baseParams,
                cleaner: { userId: oldCleanerId, name: oldCleaner.Name, email: oldCleaner.Emailaddress, phone: oldCleaner.PhoneNumber },
                isActionRequired: false,
                inAppMessageCleanerKey: "in-AppNotifications.taskRemovedMessage",
                inAppMessageCleanerParams: { taskName: raw.TaskName, clientName: raw.Relation?.Name, date: moment(event.start).format("DD-MM-YYYY") },
                inAppManagerSuffixKey: "in-AppNotifications.orderUnassignedManagerSuffix",
                inAppManagerSuffixParams: { clientName: raw.Relation?.Name },
              });
              await dispatchBatchNotification({ customerId, eventKey: "TASK_UNASSIGNED", entries: [unassignEntry] });
            }

            const assignEntry = buildTaskNotificationEntry({
              ...baseParams,
              cleaner: { userId: newCleanerId, name: newCleaner.Name, email: newCleaner.Emailaddress, phone: newCleaner.PhoneNumber },
              isActionRequired: true,
              inAppMessageCleanerKey: "in-AppNotifications.taskAssignedMessage",
              inAppMessageCleanerParams: { taskName: raw.TaskName, clientName: raw.Relation?.Name },
              inAppManagerSuffixKey: "in-AppNotifications.taskAssignedManagerSuffix",
              inAppManagerSuffixParams: { taskName: raw.TaskName, clientName: raw.Relation?.Name },
              whatsappTemplateName: `task_assignment_marketing_${culture}`,
              whatsappParameters: [newCleaner.Name, raw.TaskName, newStart.format("DD-MM-YYYY HH:mm"), location, newStart.format("DD-MM-YYYY"), newStart.format("DD-MM-YYYY")],
            });
            await dispatchBatchNotification({ customerId, eventKey: "TASK_ASSIGNED", entries: [assignEntry] });
          } catch (notifErr) {
            console.error("[DROP] Notification error (non-blocking):", notifErr);
          }
        })();
      }

      // Refresh calendar data
      lastFetchKeyRef.current = null;
      const api = calendarRef.current?.getApi();
      if (api?.view) {
        const start = moment(api.view.activeStart).toDate();
        const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
        fetchCalendarData(start, end, false);
      }

    } catch (error) {
      console.error(`[DROP] PATCH failed:`, error);
      toast.error(t("planningUpdateFailed"), { position: "top-right" });
      info.revert();
      if (isEmployeeChanged) {
        setResourceList((prev) =>
          prev.map((r) => {
            if (r.id === oldCleanerId) return { ...r, extendedProps: { ...r.extendedProps, workedHours: (r.extendedProps?.workedHours || 0) + durationHours } };
            if (r.id === newCleanerId) return { ...r, extendedProps: { ...r.extendedProps, workedHours: Math.max(0, (r.extendedProps?.workedHours || 0) - durationHours) } };
            return r;
          })
        );
      }
      lastFetchKeyRef.current = null;
      const api = calendarRef.current?.getApi();
      if (api?.view) {
        const start = moment(api.view.activeStart).toDate();
        const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
        fetchCalendarData(start, end, false);
      }
    }
  };

const handleRemoveThisCleaner = async () => {
    if (!selectedOrderDetailId) return;

    try {
      const targetEvent = initialEvents.find(e => e.id === selectedOrderDetailId);
      const raw = targetEvent?.extendedProps?.rawData;

      await deleteCleanerByOrderDetailId(selectedOrderDetailId, localStorage.getItem("UserId"));

      toast.success(t("employeeRemovedSuccessfully"), { position: "top-right" });

      setShowCleanerDeleteModal(false);
      setSelectedOrderDetailId(null);
      setDrawerOpen(false);

      lastFetchKeyRef.current = null;
      initialFetchDoneRef.current = false;

      const api = calendarRef.current?.getApi();
      if (api?.view) {
        const start = moment(api.view.activeStart).toDate();
        const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
        fetchCalendarData(start, end, false);
      }

      // ── Notification — fire-and-forget, non-blocking ──
      if (raw?.CleanerId) {
        (async () => {
          try {
            const customerId = localStorage.getItem("customerId");
            const userId = localStorage.getItem("UserId");
            const culture = localStorage.getItem("culture") || "nl";
            const cleaner = allEmployees.find(e => e.UserId === raw.CleanerId);
            if (!cleaner) return;

            const taskDate = moment(raw.WeekStartDate).isoWeekday(raw.DayOfWeek).format("YYYY-MM-DD");
            const frequency = await fetchFrequencyLabel(raw.ProposalId, raw.ProposalTaskId, t);
            const location = [raw.Relation?.StreetName, raw.Relation?.PostCode, raw.Relation?.City].filter(Boolean).join(", ");

            const entry = buildTaskNotificationEntry({
              cleaner: { userId: raw.CleanerId, name: cleaner.Name, email: cleaner.Emailaddress, phone: cleaner.PhoneNumber },
              taskName: raw.TaskName,
              clientName: raw.Relation?.Name,
              location,
              date: taskDate,
              startTime: raw.StartTime ? moment(raw.StartTime).local().format("HH:mm") : null,
              endTime: raw.EndTime ? moment(raw.EndTime).local().format("HH:mm") : null,
              frequency,
              culture,
              organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
              userId,
              sourceId: raw.OrderId,
              isActionRequired: false,
              inAppMessageCleanerKey: "in-AppNotifications.taskRemovedMessage",
              inAppMessageCleanerParams: { taskName: raw.TaskName, clientName: raw.Relation?.Name, date: moment(taskDate).format("DD-MM-YYYY") },
              inAppManagerSuffixKey: "in-AppNotifications.orderUnassignedManagerSuffix",
              inAppManagerSuffixParams: { clientName: raw.Relation?.Name },
              t,
            });
            // useMultiTaskTemplate keeps this on sendMultiTaskUnassignmentEmail server-side, matching prior behavior
            entry.data.useMultiTaskTemplate = true;

            await dispatchBatchNotification({ customerId, eventKey: "TASK_UNASSIGNED", entries: [entry] });
          } catch (err) {
            console.error("Unassignment notification error (non-blocking):", err);
          }
        })();
      }

    } catch (error) {
      toast.error(t("failedToRemoveCleaner"), { position: "top-right" });
    }
  };

const handleRemoveAllCleanersForDay = async () => {
    if (!selectedEmployeeId || !selectedTaskDate) {
      console.error("Missing required data for Remove All:", { selectedEmployeeId, selectedTaskDate });
      toast.error(t("failedToRemoveCleaner"), { position: "top-right" });
      return;
    }

    try {
      const affectedEvents = initialEvents.filter(e =>
        !e.extendedProps?.isLeave &&
        e.extendedProps?.rawData?.CleanerId === selectedEmployeeId &&
        moment(e.start).format("YYYY-MM-DD") === selectedTaskDate
      );

      await deleteAllCleanerOrderDetailsForDay(
        selectedEmployeeId,
        selectedTaskDate,
        localStorage.getItem("customerId"),
        localStorage.getItem("LocationId"),
        localStorage.getItem("UserId"),
      );

      toast.success(t("allCleanersRemovedSuccessfully"), { position: "top-right" });

      lastFetchKeyRef.current = null;
      initialFetchDoneRef.current = false;

      setShowCleanerDeleteModal(false);
      setSelectedOrderDetailId(null);
      setSelectedEmployeeId(null);
      setSelectedTaskDate(null);
      setDrawerOpen(false);

      const api = calendarRef.current?.getApi();
      if (api?.view) {
        const start = moment(api.view.activeStart).toDate();
        const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
        fetchCalendarData(start, end, false);
      }

      // ── Notifications — fire-and-forget, grouped by cleaner ──
      if (affectedEvents.length > 0) {
        (async () => {
          try {
            const customerId = localStorage.getItem("customerId");
            const userId = localStorage.getItem("UserId");
            const culture = localStorage.getItem("culture") || "nl";

            const tasksByCleaner = {};
            affectedEvents.forEach(e => {
              const raw = e.extendedProps?.rawData;
              if (!raw?.CleanerId) return;
              if (!tasksByCleaner[raw.CleanerId]) tasksByCleaner[raw.CleanerId] = [];
              tasksByCleaner[raw.CleanerId].push(raw);
            });

            const entries = Object.entries(tasksByCleaner).map(([cleanerId, tasks]) => {
              const cleaner = allEmployees.find(e => e.UserId === cleanerId);
              if (!cleaner) return null;
              const firstRaw = tasks[0];
              const location = [firstRaw.Relation?.StreetName, firstRaw.Relation?.PostCode, firstRaw.Relation?.City].filter(Boolean).join(", ");

              return {
                cleaner: { userId: cleanerId, name: cleaner.Name, email: cleaner.Emailaddress, phone: cleaner.PhoneNumber },
                data: {
                  orderInfo: {
                    clientName: firstRaw.Relation?.Name,
                    location,
                    startDate: selectedTaskDate,
                    endDate: selectedTaskDate,
                    tasks: tasks.map(raw => ({
                      taskName: raw.TaskName,
                      startTime: raw.StartTime ? moment.utc(raw.StartTime).format("HH:mm") : null,
                      endTime: raw.EndTime ? moment.utc(raw.EndTime).format("HH:mm") : null,
                    })),
                  },
                  culture,
                  organizationName: process.env.REACT_APP_ORGANIZATION_NAME,
                  userId,
                  raisedFrom: userId,
                  isActionRequired: false,
                  sourceId: firstRaw.OrderId,
                  sourceType: "order",
                  sourceDate: selectedTaskDate,
                  inAppMessageCleaner: t("in-AppNotifications.allTasksRemovedMessage", { date: moment(selectedTaskDate).format("DD-MM-YYYY") }),
                  inAppManagerSuffix: t("in-AppNotifications.orderUnassignedManagerSuffix", { clientName: firstRaw.Relation?.Name }),
                  useMultiTaskTemplate: true,
                }
              };
            }).filter(Boolean);

            await dispatchBatchNotification({ customerId, eventKey: "TASK_UNASSIGNED", entries });
          } catch (err) {
            console.error("Bulk unassignment notification error (non-blocking):", err);
          }
        })();
      }

    } catch (error) {
      console.error("Failed to delete all cleaners:", error);
      toast.error(t("failedToRemoveCleaner"), { position: "top-right" });
    }
  };

  const handleUnavailabilityUpdated = () => {
    lastFetchKeyRef.current = null;
    const api = calendarRef.current?.getApi();
    if (api?.view) {
      const start = moment(api.view.activeStart).toDate();
      const end = moment(api.view.activeEnd).subtract(1, 'day').toDate();
      fetchCalendarData(start, end, false);
    }
  };

const handleUnavailabilityDecision = async (unavailabilityId, newStatus, note) => {
    setLeaveDecisionLoading(`${unavailabilityId}-${newStatus}`);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/updateStatus/${unavailabilityId}`,
        {
          status: newStatus,
          decisionOn: moment().format('YYYY-MM-DD'),
          decisionBy: localStorage.getItem('UserId'),
          adminNote: note || null,
        },
        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
      );
      toast.success(
        newStatus === 'approved'
          ? t('leaveApprovedSuccessfully')
          : t('leaveRejectedSuccessfully'),
        { position: 'top-right', autoClose: 2000 }
      );
      lastFetchKeyRef.current = null;
      const api = calendarRef.current?.getApi();
      if (api?.view) {
        const start = moment(api.view.activeStart).toDate();
        const end = moment(api.view.activeEnd).subtract(1, 'day').toDate();
        fetchCalendarData(start, end, false);
      }

      // ── Notification — fire-and-forget, routed through the centralized dispatcher ──
      notifyLeaveDecision({
        unavailabilityId,
        updatedRecord: response.data,
        newStatus,
        note,
        adminId: localStorage.getItem('UserId'),
        customerId: localStorage.getItem('customerId'),
        t,
      }).catch(err => console.error('Leave decision notification error (non-blocking):', err));

    } catch (err) {
      console.error('Leave decision error:', err);
      toast.error(
        newStatus === 'approved'
          ? t('failedToApproveLeave')
          : t('failedToRejectLeave'),
        { position: 'top-right', autoClose: 2000 }
      );
    } finally {
      setLeaveDecisionLoading(null);
    }
  };
  
  const handleDatesSet = (arg) => {
    const api = calendarRef.current?.getApi();
    if (!api) return;

    if (skipNextDatesSetRef.current) {
      skipNextDatesSetRef.current = false;
      return;
    }

    const start = moment(arg.start).toDate();
    const end = moment(arg.end).subtract(1, "day").toDate();
    const viewType = arg.view.type;

    setCurrentView(viewType);
    setTitle(getFormattedCalendarTitle(arg.view, t));
    setVisibleStartDate(start);
    setVisibleEndDate(end);

    let calendarMode = "week";
    if (viewType === "resourceTimelineDay") calendarMode = "day";
    if (viewType === "resourceTimelineWeek") calendarMode = "week";
    if (viewType === "dayGridMonth") calendarMode = "month";
    setCalendarView(calendarMode);

    if (pendingLocationReloadRef.current) return;

    if (!employeeList.length) return;

    const fetchKey = `${locationId}_${calendarMode}_${start.toISOString()}_${end.toISOString()}_${selectedOrderId || "none"}`;
    if (lastFetchKeyRef.current === fetchKey) return;
    lastFetchKeyRef.current = fetchKey;
    fetchCalendarData(start, end, false);
  };

  useEffect(() => {
    if (!pendingLocationReloadRef.current) return;
    if (!employeeList.length) return;
    if (!calendarRef.current) return;

    pendingLocationReloadRef.current = false;
    const api = calendarRef.current.getApi();
    const view = api.view;

    const start = moment(view.activeStart).toDate();
    const end = moment(view.activeEnd).subtract(1, "day").toDate();

    fetchCalendarData(start, end, true);
  }, [employeeList.length, locationId]);

  useEffect(() => {
    if (
      isMobileView &&
      mobileWeekStart &&
      mobileWeekEnd &&
      employeeList.length &&
      locationId
    ) {
      setInitialLoading(true);

      const start = mobileWeekStart.toDate();
      const end = mobileWeekEnd.toDate();

      const fetchKey = `${locationId}_${start.toISOString()}_${end.toISOString()}`;
      if (lastFetchKeyRef.current === fetchKey) {
        setInitialLoading(false);
        return;
      }

      lastFetchKeyRef.current = fetchKey;

      fetchCalendarData(start, end, true).finally(() => { });
    }
  }, [
    isMobileView,
    mobileWeekStart,
    mobileWeekEnd,
    employeeList.length,
    locationId,
  ]);

  useEffect(() => {
    if (!calendarApi || !calendarApi.view) return;
    const currentView = calendarApi.view.type;

    let translatedLabel = "";
    switch (currentView) {
      case "timeGridWeek":
        translatedLabel = t("calendar.weekView");
        break;
      case "resourceTimelineWeek":
        translatedLabel = effectiveUserRole === USER_ROLES.EMPLOYEE
          ? t("calendar.clientOverview")
          : t("calendar.employeeOverview");
        break;
      default:
        translatedLabel = t("calendar.weekView");
    }

    setCurrentFilter(translatedLabel);
  }, [i18n.language, effectiveUserRole]);

  useEffect(() => {
    clickedSubtasksRef.current = new Set();
  }, [selectedEvent]);

  useEffect(() => {
    const api = calendarRef.current?.getApi();
    if (!api) return;
    const lang = i18n.language.split("-")[0];
    api.setOption("locale", lang);
    setCalendarApi(api);
    setCurrentFilter(isEmployeeViewToggle ? "employees" : "clients");
  }, [i18n.language]);

  useEffect(() => {
    const api = calendarRef.current?.getApi();
    if (!api?.view) return;

    const currentDate = api.getDate();
    const newView = showHoursHeader ? "resourceTimelineWeek" : "timeGridWeek";

    if (api.view.type === newView) return;

    skipNextDatesSetRef.current = true;
    api.changeView(newView);
    api.gotoDate(currentDate);
  }, [showHoursHeader]);


  useEffect(() => {
    if (!calendarReady) return;
    const api = calendarRef.current?.getApi();
    if (!api?.view) return;
    setTitle(getFormattedCalendarTitle(api.view, t));
  }, [calendarReady]);

  useEffect(() => {
    if (calendarRef.current) {
      calendarRef.current.getApi().updateSize();
    }

    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (calendarRef.current) {
          const api = calendarRef.current.getApi();
          api.updateSize();
          api.render();
        }
      }, 150);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  useEffect(() => {
    if (effectiveUserRole === USER_ROLES.EMPLOYEE) {
      setSelectedClientPlanning(null);
    } else {
      setSelectedClientPlanning("all");
    }
  }, [effectiveUserRole]);

  const handleOrderDropdownSelect = (order) => {
    setSelectedOrderId(order.orderId);
    setSelectedOrderClient(order.clientName);
    setSelectedDropdownOrderId(order.orderId);
    setInitialEvents([]);
    setResourceList([]);
    lastFetchKeyRef.current = null;
    fetchInProgressRef.current = false;
    const api = calendarRef.current?.getApi();
    if (api?.view) {
      const start = moment(api.view.activeStart).toDate();
      const end = moment(api.view.activeEnd).subtract(1, "day").toDate()
      fetchCalendarData(start, end, false, "drilldown");
    }
  };

  const OrderDropdown = ({ orders, selectedDropdownOrderId, onOrderSelect, t, disabled = false }) => {
    const options = orders.map((o) => ({
      value: o.orderId,
      label: o.orderNumber,
      subLabel: o.templateName,
      order: o,
    }));

    const formatOptionLabel = ({ label }) => (
      <div className="font-size-13">{label}</div>
    );

    return (
      <div className="d-flex align-items-center input-group-sm filter-group border rounded overflow-hidden w-auto">
        <span className="px-2 bg-light border-end h-100 d-flex align-items-center">
          <i className="fas fa-clipboard-list text-600" />
        </span>
        <Select
          options={options}
          value={options.find((o) => o.value === selectedDropdownOrderId) || null}
          onChange={(opt) => opt && !disabled && onOrderSelect(opt.order)}
          formatOptionLabel={formatOptionLabel}
          placeholder={t("selectOrder")}
          isSearchable
          isDisabled={disabled}
          isClearable={false}
          noOptionsMessage={() => t("noOptionsAvailable")}
          classNamePrefix="custom-select"
          className="custom-select-container"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            container: (base) => ({
              ...base,
              width: "auto",
            }),
            control: (base) => ({
              ...base,
              border: "none",
              boxShadow: "none",
              minHeight: "32px",
              height: "32px",
              minWidth: "100px",
              width: "auto",
              fontSize: "13px",
              cursor: "pointer",
              backgroundColor: "transparent",
              flexWrap: "nowrap",
            }),
            valueContainer: (base) => ({
              ...base,
              padding: "0 6px",
              flexWrap: "nowrap",
              width: "auto",
              flex: "1 1 auto",
            }),
            singleValue: (base) => ({
              ...base,
              fontSize: "13px",
              color: "inherit",
              position: "relative",
              top: "auto",
              transform: "none",
              maxWidth: "none",
              overflow: "visible",
              whiteSpace: "nowrap",
            }),
            indicatorsContainer: (base) => ({ ...base, height: "32px" }),
            dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
            clearIndicator: (base) => ({ ...base, padding: "4px" }),
            input: (base) => ({
              ...base,
              fontSize: "13px",
              margin: 0,
              padding: 0,
              width: "auto",
            }),
            placeholder: (base) => ({ ...base, fontSize: "13px", color: "#6c757d", whiteSpace: "nowrap" }),
            menu: (base) => ({ ...base, fontSize: "13px", minWidth: "200px" }),
            menuList: (base) => ({ ...base, maxHeight: "240px", overflowY: "auto" }),
            option: (base, state) => ({
              ...base,
              fontSize: "13px",
              padding: "6px 10px",
              backgroundColor: state.isSelected ? "#e9ecef" : state.isFocused ? "#f8f9fa" : "#fff",
              color: "#212529",
              cursor: "pointer",
            }),
          }}
        />
      </div>
    );
  };

  const EmployeeSearchDropdown = ({ employees, selectedEmployee, setSelectedEmployee, t, disabled = false }) => {
    const options = [
      {
        label: t("actions"),
        options: [{ value: "all", label: t("allEmployees") }],
      },
      {
        label: t("employees"),
        options: employees.map((e) => ({ value: e.UserId, label: e.Name })),
      },
    ];

    const selectedValue =
      !selectedEmployee || selectedEmployee === "all"
        ? { value: "all", label: t("allEmployees") }
        : options[1].options.find((o) => o.value === selectedEmployee) || null;

    return (
      <div className="d-flex align-items-center input-group-sm filter-group border rounded overflow-hidden w-auto">
        <span className="px-2 bg-light border-end h-100 d-flex align-items-center">
          <i className="fas fa-users text-600" />
        </span>
        <Select
          options={options}
          value={selectedValue}
          onChange={(opt) => setSelectedEmployee(opt?.value === "all" ? null : opt?.value || null)}
          placeholder={t("searchEmployee")}
          isSearchable
          isDisabled={disabled}
          isClearable={false}
          noOptionsMessage={() => t("noOptionsAvailable")}
          classNamePrefix="custom-select"
          className="custom-select-container"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            container: (base) => ({ ...base, width: "auto" }),
            control: (base) => ({ ...base, border: "none", boxShadow: "none", minHeight: "32px", height: "32px", minWidth: "100px", width: "auto", fontSize: "13px", cursor: "pointer", backgroundColor: "transparent", flexWrap: "nowrap" }),
            valueContainer: (base) => ({ ...base, padding: "0 6px", flexWrap: "nowrap", width: "auto", flex: "1 1 auto" }),
            singleValue: (base) => ({ ...base, fontSize: "13px", color: "inherit", position: "relative", top: "auto", transform: "none", maxWidth: "none", overflow: "visible", whiteSpace: "nowrap" }),
            indicatorsContainer: (base) => ({ ...base, height: "32px" }),
            dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
            clearIndicator: (base) => ({ ...base, padding: "4px" }),
            input: (base) => ({ ...base, fontSize: "13px", margin: 0, padding: 0, width: "auto" }),
            placeholder: (base) => ({ ...base, fontSize: "13px", color: "#6c757d", whiteSpace: "nowrap" }),
            menu: (base) => ({ ...base, fontSize: "13px", minWidth: "200px" }),
            menuList: (base) => ({ ...base, maxHeight: "240px", overflowY: "auto" }),
            option: (base, state) => ({ ...base, fontSize: "13px", padding: "6px 10px", backgroundColor: state.isSelected ? "#e9ecef" : state.isFocused ? "#f8f9fa" : "#fff", color: "#212529", cursor: "pointer" }),
            groupHeading: (base) => ({ ...base, fontSize: "11px", fontWeight: 600, padding: "4px 10px", textTransform: "uppercase", color: "#6c757d" }),
            group: (base) => ({ ...base, paddingTop: 0, paddingBottom: 0 }),
          }}
        />
      </div>
    );
  };

  const ClientSearchDropdown = ({ clients, selectedClientPlanning, setSelectedClientPlanning, setSelectedEmployee, t, disabled = false }) => {
    const options = [
      {
        label: t("actions"),
        options: [{ value: "all", label: t("allClients") }],
      },
      {
        label: t("clients"),
        options: clients.map((c) => ({ value: c.RelationNumber, label: c.Name })),
      },
    ];

    const allOptions = clients.map((c) => ({ value: c.RelationNumber, label: c.Name }));
    const selectedValue =
      selectedClientPlanning === "all" || !selectedClientPlanning
        ? { value: "all", label: t("allClients") }
        : allOptions.find((o) => o.value === selectedClientPlanning) || null;

    return (
      <div className="d-flex align-items-center input-group-sm filter-group border rounded overflow-hidden w-auto">
        <span className="px-2 bg-light border-end h-100 d-flex align-items-center">
          <i className="fas fa-user text-600" />
        </span>
        <Select
          options={options}
          value={selectedValue}
          onChange={(opt) => {
            setSelectedClientPlanning(opt?.value || "all");
            setSelectedEmployee(null);
          }}
          placeholder={t("searchClient")}
          isSearchable
          isDisabled={disabled}
          isClearable={false}
          noOptionsMessage={() => t("noOptionsAvailable")}
          classNamePrefix="custom-select"
          className="custom-select-container"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            container: (base) => ({
              ...base,
              width: "auto",
            }),
            control: (base) => ({
              ...base,
              border: "none",
              boxShadow: "none",
              minHeight: "32px",
              height: "32px",
              minWidth: "100px",
              width: "auto",
              fontSize: "13px",
              cursor: "pointer",
              backgroundColor: "transparent",
              flexWrap: "nowrap",
            }),
            valueContainer: (base) => ({
              ...base,
              padding: "0 6px",
              flexWrap: "nowrap",
              width: "auto",
              flex: "1 1 auto",
            }),
            singleValue: (base) => ({
              ...base,
              fontSize: "13px",
              color: "inherit",
              position: "relative",
              top: "auto",
              transform: "none",
              maxWidth: "none",
              overflow: "visible",
              whiteSpace: "nowrap",
            }),
            indicatorsContainer: (base) => ({ ...base, height: "32px" }),
            dropdownIndicator: (base) => ({ ...base, padding: "4px" }),
            clearIndicator: (base) => ({ ...base, padding: "4px" }),
            input: (base) => ({
              ...base,
              fontSize: "13px",
              margin: 0,
              padding: 0,
              width: "auto",
            }),
            placeholder: (base) => ({ ...base, fontSize: "13px", color: "#6c757d", whiteSpace: "nowrap" }),
            menu: (base) => ({ ...base, fontSize: "13px", minWidth: "200px" }),
            menuList: (base) => ({ ...base, maxHeight: "240px", overflowY: "auto" }),
            option: (base, state) => ({
              ...base,
              fontSize: "13px",
              padding: "6px 10px",
              backgroundColor: state.isSelected ? "#e9ecef" : state.isFocused ? "#f8f9fa" : "#fff",
              color: "#212529",
              cursor: "pointer",
            }),
            groupHeading: (base) => ({
              ...base,
              fontSize: "11px",
              fontWeight: 600,
              padding: "4px 10px",
              textTransform: "uppercase",
              color: "#6c757d",
            }),
            group: (base) => ({ ...base, paddingTop: 0, paddingBottom: 0 }),
          }}
        />
      </div>
    );
  };

  const loadingOrRedirect = handleLoadingAndAccess(isLoading, hasAccess);

  if (loadingOrRedirect) {
    return loadingOrRedirect;
  }

  const handleMobileEventClick = (event) => {
    const raw = event.extendedProps?.rawData;
    if (raw) {
      clickedSubtasksRef.current = new Set();
      openTaskDrawerForEvent(raw);
    }
  };

  const getEmployeeConflicts = () => {
    let totalConflicts = 0;

    let visibleEvents = initialEvents;

    if (selectedOrderId) {
      visibleEvents = initialEvents.filter(
        (e) => e.extendedProps?.orderId === selectedOrderId || e.extendedProps?.isLeave
      );
    } else if (selectedEmployee) {
      visibleEvents = initialEvents.filter((e) => e.resourceId === selectedEmployee);
    } else if (
      effectiveUserRole !== USER_ROLES.EMPLOYEE &&
      selectedClientPlanning &&
      selectedClientPlanning !== "all"
    ) {
      visibleEvents = initialEvents.filter((e) => {
        if (e.extendedProps?.isLeave) return true;
        return currentFilter === "clients"
          ? e.extendedProps?.rawData?.RelationId === selectedClientPlanning
          : e.extendedProps?.rawData?.CleanerId === selectedClientPlanning;
      });
    }

    const taskEvents = visibleEvents.filter((e) => !e.extendedProps?.isLeave);

    const orderDateCleanerMap = {};
    taskEvents.forEach((event) => {
      const orderId = event.extendedProps?.orderId;
      const eventDate = moment(event.start).format("YYYY-MM-DD");
      const cleanerId = event.extendedProps?.rawData?.CleanerId;
      if (!orderId || !cleanerId) return;

      const key = `${orderId}_${eventDate}`;
      if (!orderDateCleanerMap[key]) orderDateCleanerMap[key] = new Set();
      orderDateCleanerMap[key].add(cleanerId);
    });

    const countedKeys = new Set();

    Object.entries(orderDateCleanerMap).forEach(([key, cleanerIds]) => {
      const [orderId, eventDate] = key.split("_");

      cleanerIds.forEach((cleanerId) => {
        const conflictKey = `${orderId}_${eventDate}_${cleanerId}`;
        if (countedKeys.has(conflictKey)) return;

        const hasLeaveOnDate = conflictMap[cleanerId]?.dates?.has(eventDate);

        if (hasLeaveOnDate) {
          totalConflicts += 1;
          countedKeys.add(conflictKey);
        }
      });
    });

    return totalConflicts;
  };
  const totalEmployeeConflicts = getEmployeeConflicts();

  const handleMobileWeekChange = async (newWeekStart, newWeekEnd) => {
    if (fetchInProgressRef.current) {
      return;
    }

    setLoading(true);

    const weekStartMoment = moment(newWeekStart).startOf("isoWeek");
    const weekEndMoment = moment(newWeekEnd).endOf("isoWeek");

    setMobileWeekStart(weekStartMoment);
    setMobileWeekEnd(weekEndMoment);

    try {
      await fetchCalendarData(
        weekStartMoment.toDate(),
        weekEndMoment.toDate(),
        false,
      );
    } catch (error) {
      console.error("Error fetching week data:", error);
    } finally {
      setLoading(false);
    }
  };

// ============================================================
// FULLCALENDAR DISPLAY DATA
// Calculate once per React render instead of inside JSX
// ============================================================

let calendarDisplayResources;

if (selectedOrderId && !isNavigatingBackRef.current) {
  calendarDisplayResources = buildResourcesFromOrderEmployees(
    initialEvents,
    selectedOrderId
  );
} else if (selectedEmployee) {
  calendarDisplayResources = resourceList.filter(
    (r) => r.id === selectedEmployee
  );
} else if (
  effectiveUserRole !== USER_ROLES.EMPLOYEE &&
  !isEmployeeViewToggle &&
  selectedClientPlanning &&
  selectedClientPlanning !== "all"
) {
  calendarDisplayResources = resourceList.filter(
    (r) => r.id === selectedClientPlanning
  );
} else {
  calendarDisplayResources = resourceList;
}


// ============================================================
// EVENTS TO DISPLAY
// ============================================================

let calendarDisplayEvents;

if (selectedOrderId && !isNavigatingBackRef.current) {
  calendarDisplayEvents = initialEvents
    .filter(
      (e) =>
        e.extendedProps?.orderId === selectedOrderId ||
        e.extendedProps?.isLeave
    )
    .map((e) => ({
      ...e,
      resourceId: e.extendedProps?.isLeave
        ? e.extendedProps?.employeeId
        : e.extendedProps?.rawData?.CleanerId,
    }));
} else if (selectedEmployee) {
  calendarDisplayEvents = initialEvents.filter(
    (e) => e.resourceId === selectedEmployee
  );
} else if (
  effectiveUserRole !== USER_ROLES.EMPLOYEE &&
  !isEmployeeViewToggle &&
  selectedClientPlanning &&
  selectedClientPlanning !== "all"
) {
  calendarDisplayEvents = initialEvents.filter((e) => {
    if (e.extendedProps?.isLeave) return true;

    return currentFilter === "clients"
      ? e.extendedProps?.rawData?.RelationId === selectedClientPlanning
      : e.extendedProps?.rawData?.CleanerId === selectedClientPlanning;
  });
} else {
  calendarDisplayEvents = initialEvents;
}


// ============================================================
// MONTH VIEW
// ============================================================

if (calendarView === "month") {
  if (
    !isEmployeeViewToggle &&
    effectiveUserRole !== USER_ROLES.EMPLOYEE
  ) {
    const seen = new Set();

    calendarDisplayEvents = calendarDisplayEvents.filter((e) => {
      if (e.extendedProps?.isLeave) return false;

      const orderId = e.extendedProps?.orderId;
      const date = moment(e.start).format("YYYY-MM-DD");
      const key = `${orderId}_${date}`;

      if (seen.has(key)) return false;

      seen.add(key);
      return true;
    });
  } else {
    calendarDisplayEvents = calendarDisplayEvents.filter(
      (e) => !e.extendedProps?.isLeave
    );
  }
}


// ============================================================
// NORMAL CLIENT VIEW
// ============================================================

if (
  calendarView !== "month" &&
  !selectedOrderId &&
  !isEmployeeViewToggle &&
  effectiveUserRole !== USER_ROLES.EMPLOYEE
) {
  const seen = new Set();

  calendarDisplayEvents = calendarDisplayEvents.filter((e) => {
    if (e.extendedProps?.isLeave) return true;

    const orderId = e.extendedProps?.orderId;
    const date = moment(e.start).format("YYYY-MM-DD");
    const key = `${orderId}_${date}`;

    if (seen.has(key)) return false;

    seen.add(key);
    return true;
  });
}

  return (
    <>
      <Row className="g-3 mb-3">
        <Col lg={12} xxl={12}>
          <Card className="mb-3 h-100">
            <Background
              image={corner4}
              className="bg-card"
              style={{
                borderTopRightRadius: "0.375rem",
                borderBottomRightRadius: "0.375rem",
              }}
            />

            <Card.Body className="position-relative pe-4 pb-1">
              <Row className="align-items-center justify-content-between">

                <Col>
                  {selectedOrderId ? (
                    <>
                      <h5 className="mb-0">{t("planning")}</h5>
                      <div className="text-300 fs--1 mb-1 d-flex align-items-center flex-wrap gap-1">

                        <span
                          className="fw-normal font-size-13 text-muted cursor-pointer"
                          onMouseEnter={(e) => e.currentTarget.classList.add("text-decoration-underline")}
                          onMouseLeave={(e) => e.currentTarget.classList.remove("text-decoration-underline")}
                          onClick={() => {
                            isNavigatingBackRef.current = true;
                            setSelectedOrderId(null);
                            setSelectedOrderClient(null);
                            skipNextDatesSetRef.current = true;
                            lastFetchKeyRef.current = null;
                            setCurrentFilter(isEmployeeViewToggle ? "employees" : "clients");
                            setInitialEvents([]);
                            setResourceList([]);
                            setSelectedDropdownOrderId(null);
                            setSelectedClientPlanning("all");
                            setSelectedEmployee(null);

                            const api = calendarRef.current?.getApi();
                            if (api?.view) {
                              const start = moment(api.view.activeStart).toDate();
                              const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
                              fetchCalendarData(start, end, false, "clients");
                            }
                          }}
                        >
                          {t("clients")}
                        </span>

                        <span className="fw-bold font-size-14 text-600">/</span>

                        {selectedOrderClient && (
                          <>
                            <span
                              className="fw-normal font-size-13 text-muted cursor-pointer"
                              onMouseEnter={(e) => e.currentTarget.classList.add("text-decoration-underline")}
                              onMouseLeave={(e) => e.currentTarget.classList.remove("text-decoration-underline")}
                              onClick={() => {
                                isNavigatingBackRef.current = true;
                                const clientRelationId = initialEvents
                                  .find(e => e.extendedProps?.orderId === selectedOrderId && !e.extendedProps?.isLeave)
                                  ?.extendedProps?.rawData?.RelationId || "all";

                                setSelectedOrderId(null);
                                setSelectedOrderClient(null);
                                skipNextDatesSetRef.current = true;
                                lastFetchKeyRef.current = null;
                                setCurrentFilter("clients");
                                setInitialEvents([]);
                                setResourceList([]);
                                setSelectedDropdownOrderId(null);
                                setSelectedClientPlanning(clientRelationId); 
                                setSelectedEmployee(null);

                                const api = calendarRef.current?.getApi();
                                if (api?.view) {
                                  const start = moment(api.view.activeStart).toDate();
                                  const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
                                  fetchCalendarData(start, end, false, "clients");
                                }
                              }}
                            >
                              {selectedOrderClient}
                            </span>

                            <span className="fw-bold font-size-14 text-600">/</span>
                          </>
                        )}
                        <span className="fw-semibold font-size-13 text-muted">
                          {t("employeePlanning")}
                        </span>
                      </div>
                    </>
                  ) : (
                    <h5 className="mb-0">{t("planning")}</h5>
                  )}
                </Col>

                {/* RIGHT SIDE BUTTON */}
                <Col xs="auto" className="d-flex align-items-center gap-2">
                  {!isReadOnly && !selectedOrderId && !isMobileView && userRole !== USER_ROLES.CLIENT && (
                    <div className="d-inline-flex align-items-center rounded-pill p-1 bg-custom-light border gap-2px">
                      <button
                        type="button"
                        onClick={() =>
                          !isCalendarLoading && !selectedOrderId && handleViewToggle(true)
                        }
                        disabled={isCalendarLoading || !!selectedOrderId}
                        className={`border-0 rounded-pill px-2 py-0 fw-medium font-size-13 ${isEmployeeViewToggle
                          ? "toggle-btn-selected"
                          : "bg-transparent text-secondary"
                          }`}
                      >
                        {t("employees")}
                      </button>
                      <button
                        type="button"
                        onClick={() =>
                          !isCalendarLoading && !selectedOrderId && handleViewToggle(false)
                        }
                        disabled={isCalendarLoading || !!selectedOrderId}
                        className={`border-0 rounded-pill px-2 py-0 fw-medium font-size-13 ${!isEmployeeViewToggle
                          ? "toggle-btn-selected"
                          : "bg-transparent text-secondary"
                          }`}
                      >
                        {t("clients")}
                      </button>
                    </div>
                  )}
                  {!isReadOnly && (
                    <>
                      <Button
                        variant="primary"
                        size="sm"
                        data-tour="new-planning-btn"
                        onClick={() => setShowCreateOrder(true)}
                      >
                        <FontAwesomeIcon icon="plus" className="me-1" />
                        {t("newPlanning")}
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {isMobileView ? (
        <div className="mobile-planning-container">
          <MobilePlanningList
            events={initialEvents}
            onEventClick={handleMobileEventClick}
            onWeekChange={handleMobileWeekChange}
            currentWeekStart={mobileWeekStart?.toDate()}
            currentWeekEnd={mobileWeekEnd?.toDate()}
            isLoading={loading || initialLoading || locationChangeLoading}
            onNewPlanning={!isReadOnly ? () => setShowCreateOrder(true) : null}
          />
        </div>
      ) : (
        <Row className={`g-3 position-relative ${userRole === USER_ROLES.CLIENT ? "fc-client-autoheight" : "fc-full-height-adjusted"}`}>
          <Col lg={12} xl={12} className={userRole === USER_ROLES.CLIENT ? "align-self-start" : ""}>
            <Card className={`${userRole === USER_ROLES.CLIENT ? "" : "h-100"} d-flex flex-column`} style={{ minHeight: 0 }}>
              <Card.Header>
                <Row className="align-items-center gx-3">
                  {effectiveUserRole !== USER_ROLES.EMPLOYEE && userRole !== USER_ROLES.CLIENT && (
                    <Col xs={12} md="auto" className="d-flex align-items-center gap-2">
                      {isEmployeeViewToggle ? (
                        <EmployeeSearchDropdown
                          employees={userRole === USER_ROLES.CLIENT ? allEmployees : employeeList}
                          selectedEmployee={selectedEmployee}
                          setSelectedEmployee={setSelectedEmployee}
                          disabled={isCalendarLoading || !!selectedOrderId}
                          t={t}
                        />
                      ) : (
                        <>
                          <ClientSearchDropdown
                            clients={clients}
                            selectedClientPlanning={selectedClientPlanning}
                            setSelectedClientPlanning={(newClientId) => {
                              setSelectedClientPlanning(newClientId);
                              setSelectedEmployee(null);

                              if (newClientId === "all" && selectedOrderId) {
                                isNavigatingBackRef.current = true;
                                setSelectedOrderId(null);
                                setSelectedOrderClient(null);
                                setSelectedDropdownOrderId(null);
                                lastFetchKeyRef.current = null;
                                setCurrentFilter("clients");
                                setInitialEvents([]);
                                setResourceList([]);
                                const api = calendarRef.current?.getApi();
                                if (api?.view) {
                                  const start = moment(api.view.activeStart).toDate();
                                  const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
                                  fetchCalendarData(start, end, false, "clients");
                                }
                                return;
                              }

                              if (selectedOrderId && newClientId && newClientId !== "all") {
                                const clientOrders = clientOrdersMap[newClientId] || [];
                                if (clientOrders.length > 0) {
                                  const latestOrder = clientOrders[clientOrders.length - 1];
                                  setSelectedOrderId(latestOrder.orderId);
                                  setSelectedOrderClient(latestOrder.clientName);
                                  setSelectedDropdownOrderId(latestOrder.orderId);
                                  setInitialEvents([]);
                                  setResourceList([]);
                                  lastFetchKeyRef.current = null;
                                  fetchInProgressRef.current = false;
                                  const api = calendarRef.current?.getApi();
                                  if (api?.view) {
                                    const start = moment(api.view.activeStart).toDate();
                                    const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
                                    fetchCalendarData(start, end, false, "drilldown");
                                  }
                                }
                              }
                            }}
                            setSelectedEmployee={setSelectedEmployee}
                            disabled={isCalendarLoading}
                            t={t}
                          />
                          {selectedOrderId && !isNavigatingBackRef.current && (() => {
                            const clientRelationId = initialEvents
                              .find(e => e.extendedProps?.orderId === selectedOrderId && !e.extendedProps?.isLeave)
                              ?.extendedProps?.rawData?.RelationId;
                            const orders = clientRelationId ? (clientOrdersMap[clientRelationId] || []) : [];
                            return orders.length > 0 ? (
                              <OrderDropdown
                                orders={orders}
                                selectedDropdownOrderId={selectedDropdownOrderId}
                                onOrderSelect={handleOrderDropdownSelect}
                                t={t}
                                disabled={isCalendarLoading}
                              />
                            ) : null;
                          })()}
                        </>
                      )}
                    </Col>
                  )}
                  <Col className="d-flex align-items-center justify-content-center gap-2 flex-grow-1">

                    <div className="calendar-title-center d-flex align-items-center gap-2">

                      <Button
                        variant="link"
                        className="icon-item icon-item-sm shadow-none p-0"
                        onClick={() => {
                          const api = calendarRef.current?.getApi();
                          api?.prev();
                          setTimeout(() => {
                            if (api?.view) setTitle(getFormattedCalendarTitle(api.view, t));
                          }, 0);
                        }}
                      >
                        <FontAwesomeIcon icon="arrow-left" />
                      </Button>

                      <div className="px-3  border rounded-3 d-flex align-items-center text-nowrap">
                        <h6 className=" py-2 text-600 font-size-13 mb-0">{title}</h6>
                      </div>

                      <Button
                        variant="link"
                        className="icon-item icon-item-sm shadow-none p-0"
                        onClick={() => {
                          const api = calendarRef.current?.getApi();
                          api?.next();
                          setTimeout(() => {
                            if (api?.view) setTitle(getFormattedCalendarTitle(api.view, t));
                          }, 0);
                        }}
                      >
                        <FontAwesomeIcon icon="arrow-right" />
                      </Button>

                    </div>
                  </Col>

                  <Col xs="auto" className="d-flex justify-content-end">
                    <div className="toggle-group d-inline-flex border rounded-3 me-2 overflow-hidden">
                      <button
                        type="button"
                        onClick={() => handleViewChange("day")}
                        className={`border-0 px-3 py-1 ${calendarView === "day" ? "active" : ""}`}
                        disabled={isCalendarLoading}
                      >
                        {t("dayLable")}
                      </button>

                      <button
                        type="button"
                        onClick={() => handleViewChange("week")}
                        className={`border-0 px-3 py-1 ${calendarView === "week" ? "active" : ""}`}
                        disabled={isCalendarLoading}
                      >
                        {t("weekLable")}
                      </button>

                      <button
                        type="button"
                        onClick={() => handleViewChange("month")}
                        className={`border-0 px-3 py-1 ${calendarView === "month" ? "active" : ""}`}
                        disabled={isCalendarLoading}
                      >
                        {t("monthLable")}
                      </button>

                    </div>

                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="expand-collapse-tooltip">
                          {expandAllTasks ? t("collapseAll") : t("expandAll")}
                        </Tooltip>
                      }
                    >
                      <Button
                        variant="light"
                        size="sm"
                        className="text-600 btn btn-falcon-default btn-sm"
                        onClick={() => setExpandAllTasks(!expandAllTasks)}
                      >
                        {expandAllTasks ? (
                          <MdCloseFullscreen size={18} />
                        ) : (
                          <MdOpenInFull size={18} />
                        )}
                      </Button>
                    </OverlayTrigger>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body
                id="planningCalendar"
                className={`p-0 app-calendar d-flex flex-column ${userRole === USER_ROLES.CLIENT ? "" : "flex-grow-1"} overflow-hidden planning-calendar-body`}
              >
                {(initialLoading ||
                  locationChangeLoading ||
                  loading ||
                  (!isMobileView && !calendarReady)) && (
                    <div className="calendar-overlay">
                      <Spinner animation="border" variant="secondary" />
                    </div>
                  )}
                <div className="planning-calendar-wrapper">
                  <FullCalendar
                    ref={calendarRef}
                    height={userRole === USER_ROLES.CLIENT ? "auto" : undefined}
                    initialDate={redirectDate || new Date()}
                    headerToolbar={false}
                    timeZone="local"
                    plugins={[
                      dayGridPlugin,
                      timeGridPlugin,
                      interactionPlugin,
                      resourceTimelinePlugin
                    ]}
                    initialView={"resourceTimelineWeek"}
                    views={{
                      timeGridWeek: {
                        eventMaxStack: selectedEmployee ? 999 : 2,
                        slotDuration: "00:30:00",
                        slotLabelFormat: {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false,
                        },
                        dayHeaderContent: undefined,
                      },
                      resourceTimelineWeek: {
                        eventMaxStack:
                          expandAllTasks || selectedEmployee ? 999 : 1,
                        editable: !isReadOnly,
                        eventDurationEditable: false,
                        slotDuration: { days: 1 },
                        slotLabelFormat: undefined,
                        slotLabelContent: function (arg) {
                          const date = arg.date;
                          const day = date.getDate();
                          const month = date.getMonth() + 1;
                          const weekdayKey = date
                            .toLocaleDateString("en-US", { weekday: "long" })
                            .toLowerCase();
                          const translatedDay = t(`days.${weekdayKey}`);
                          const isToday = moment(date).isSame(moment(), "day");

                          return {
                            html: `
                              <div class="fc-header-cell-wrapper text-center ${isToday ? "fc-header-today" : ""}">
                                <div class="fc-day-label fw-semibold">${translatedDay} ${day}/${month}</div>
                              </div>`,
                          };
                        },
                      },
                      resourceTimelineDay: {
                        eventMaxStack: expandAllTasks || selectedEmployee ? 999 : 1,
                        slotDuration: "01:00:00",
                        slotMinWidth: 100,
                        slotMinTime: "00:00:00",
                        slotMaxTime: "24:00:00",
                        slotLabelFormat: {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: false
                        }
                      },
                      dayGridMonth: {
                        dayMaxEvents: 2,
                      },
                    }}
                    stickyHeaderDates={true}
                    stickyFooterScrollbar={false}
                    viewDidMount={handleViewDidMount}
                    resourceAreaColumns={[
                      {
                        field: "title",
                        headerContent:
                          selectedOrderId && !isNavigatingBackRef.current
                            ? t("employee")
                            : effectiveUserRole === USER_ROLES.EMPLOYEE
                              ? t("client")
                              : isEmployeeViewToggle
                                ? (t("employees") || "Employees")
                                : t("clients"),
                        isMain: true,
                        cellContent: (arg) => {
                          if (!arg.resource) return null;
                          const { id, title, extendedProps } = arg.resource;

                          if (effectiveUserRole === USER_ROLES.EMPLOYEE) {
                            const initials = title
                              .split(" ")
                              .map((word) => word.charAt(0))
                              .join("")
                              .substring(0, 2)
                              .toUpperCase();

                            const colorClass = getColorFromName(title);

                            return (
                              <div className="fc-resource-name-wrapper d-flex align-items-center gap-2 w-100">
                                <div className="avatar flex-shrink-0 avatar-sm-custom">
                                  <div
                                    className={`avatar-name avatar-sm rounded-circle ${colorClass} d-flex align-items-center justify-content-center w-100 h-100 calendar-event-time`}
                                  >
                                    <span className="fw-bold">{initials}</span>
                                  </div>
                                </div>

                                <span
                                  className="calender-text fw-semibold text-truncate"
                                  title={title}
                                >
                                  {title}
                                </span>
                              </div>
                            );
                          } else {
                            const worked = extendedProps?.workedHours || 0;
                            const expected = extendedProps?.expectedHours || 40;
                            const initials = title
                              .split(" ")
                              .map((word) => word.charAt(0))
                              .join("")
                              .substring(0, 2)
                              .toUpperCase();
                            const colorClass = getColorFromName(title);
                            const avatarUrl = extendedProps?.avatar;

                            const isFilteredByDropdown = selectedClientPlanning &&
                              selectedClientPlanning !== "all" &&
                              id === selectedClientPlanning &&
                              !selectedOrderId &&
                              selectedEmployee !== id;

                            const isFilteredByClick = selectedEmployee === id &&
                              extendedProps?.isClient &&
                              !selectedOrderId;

                            return (
                              <div
                                className="fc-resource-name-wrapper d-flex align-items-start cursor-pointer gap-2 w-100"
                                onClick={() => {
                                  if (selectedEmployee === id) {
                                    setSelectedEmployee(null);
                                    setSelectedClientPlanning("all");
                                  } else {
                                    setSelectedEmployee(id);
                                    if (extendedProps?.isClient) {
                                      setSelectedClientPlanning(id);
                                    }
                                  }
                                }}
                              >
                                <div className="avatar avatar-xl flex-shrink-0">
                                  {avatarUrl ? (
                                    <img
                                      src={avatarUrl}
                                      className="rounded-circle avatar avatar-xl object-fit-cover"
                                      alt={title}
                                    />
                                  ) : (
                                    <div
                                      className={`avatar-name rounded-circle ${colorClass} fs-9 d-flex align-items-center justify-content-center`}
                                    >
                                      <span className="fw-bold">{initials}</span>
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex flex-column justify-content-start text-start w-100 overflow-hidden">
                                  <div className="d-flex align-items-center gap-2">
                                    <span
                                      className="calender-text fw-semibold mb-0 text-truncate"
                                      title={title}
                                    >
                                      {title}
                                    </span>
                                  </div>

                                  {currentFilter === "clients" && !selectedOrderId ? (
                                    <span className="mt-1 font-size-13 text-muted text-wrap text-break">
                                      {currentView === "resourceTimelineDay"
                                        ? t("ordersToday", { count: extendedProps?.todayOrders || 0 })
                                        : t("ordersThisWeek", { count: extendedProps?.weekOrders || 0 })}
                                    </span>
                                  ) : userRole === USER_ROLES.CLIENT ? (
                                    <SubtleBadge pill bg="primary" className="mt-1 fs-12 align-self-start">
                                      {`${formatDurationLocalized((extendedProps?.completedHours || 0) * 60)} / ${formatDurationLocalized((extendedProps?.scheduledHours || 0) * 60)}`}
                                    </SubtleBadge>
                                  ) : (
                                    <SubtleBadge pill bg="primary" className="mt-1 fs-12 align-self-start">
                                      {`${formatDurationLocalized(worked * 60)} / ${expected} ${t("hourUnit")}`}
                                    </SubtleBadge>
                                  )}
                                </div>
                              </div>
                            );
                          }
                        },
                      },
                    ]}
                    eventMaxStack={
                      (expandAllTasks &&
                        currentView === "resourceTimelineWeek") ||
                        selectedEmployee
                        ? 999
                        : true
                    }
                    eventClassNames={(arg) => {
                      const viewType = arg.view?.type;
                      const isResourceView =
                        viewType === "resourceTimelineWeek" ||
                        viewType === "resourceTimelineDay";

                      const isEmployeeView = effectiveUserRole === USER_ROLES.EMPLOYEE;
                      const isClientView = currentFilter === "clients";

                      if (arg.event.extendedProps?.isLeave && !isResourceView) {
                        return ["fc-event-hidden"];
                      }

                      if (arg.event.extendedProps?.isLeave) {
                        if (arg.event.extendedProps?.isLeaveBg) return [];
                        return ["leave-event-transparent"];
                      }
                      const shouldApplyStatusColor = isEmployeeView || isEmployeeViewToggle || (selectedOrderId && !isNavigatingBackRef.current);
                      return shouldApplyStatusColor
                        ? ["fc-event-white-outline"]
                        : ["fc-event-white-outline"];
                    }}
                    resourceAreaWidth="185px"
                    themeSystem="bootstrap"
                    resources={calendarDisplayResources}
                    resourceOrder={[]}
                    events={calendarDisplayEvents}

                    editable={!isReadOnly && (!!selectedOrderId || isEmployeeViewToggle)}
                    eventDrop={!isReadOnly && (!!selectedOrderId || isEmployeeViewToggle) ? handleEventDrop : undefined}
                    eventResize={!isReadOnly && (!!selectedOrderId || isEmployeeViewToggle) ? handleEventDrop : undefined}

                    eventAllow={(dropInfo, draggedEvent) => {
                      const isClientView = currentFilter === "clients" && !selectedOrderId && !isEmployeeViewToggle;
                      if (isClientView) return false;

                      if (draggedEvent.extendedProps?.isLeaveBadge) return true;
                      if (draggedEvent.extendedProps?.isLeaveBg) return false;

                      if (!dropInfo.resource) return false;

                      if (selectedOrderId || isEmployeeViewToggle) return true;
                      return true;
                    }}
                    selectable={!isReadOnly}
                    selectMirror
                    allDaySlot={false}
                    direction={isRTL ? "rtl" : "ltr"}
                    scrollTime={moment().startOf("hour").format("HH:mm:ss")}
                    nowIndicator={true}
                    slotMinTime="00:00:00"
                    slotMaxTime="24:00:00"
                    slotDuration={showHoursHeader ? { days: 1 } : { hours: 1 }}
                    eventTimeFormat={{
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    }}
                    eventClick={handleEventClick}
                    eventContent={renderEventContent}
                    eventDidMount={(info) => {
                      const orderId = info.event.extendedProps?.orderId;
                      if (!orderId) return;

                      const el = info.el;

                      el.setAttribute("data-order-id", orderId);
                    }}

                    eventOverlap={true}
                    slotEventOverlap={true}
                    eventOrder="start,-duration"
                    datesSet={(arg) => {
                      handleDatesSet(arg);
                    }}
                    firstDay={1}
                    select={handleSlotSelect}
                    schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                  />

                </div>
                {userRole !== USER_ROLES.CLIENT && (
                  <div className="planning-calendar-footer">
                    <span className=" fw-bold text-600 font-size-13 me-2">
                      {t("requiresAttention")}:
                    </span>

                    {totalEmployeeConflicts > 0 && (
                      <span className="badge rounded-pill bg-danger-subtle text-danger-emphasis px-3 py-1">
                        {t("employeeConflict", { count: totalEmployeeConflicts })}
                      </span>
                    )}

                    {totalEmployeeConflicts === 0 && (
                      <span className="badge rounded-pill bg-success-subtle text-success-emphasis px-3 py-1">
                        {t("noConflicts")}
                      </span>
                    )}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      <CleanerDeleteModal
        show={showCleanerDeleteModal}
        onClose={() => {
          setShowCleanerDeleteModal(false);
          setSelectedOrderDetailId(null);
          setSelectedEmployeeId(null);
          setSelectedTaskDate(null);
        }}
        onRemoveThis={handleRemoveThisCleaner}
        onRemoveAll={handleRemoveAllCleanersForDay}
        t={t}
      />

      <TaskDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        selectedTask={selectedEvent}
        initialSection={drawerInitialSection} 
        loading={detailsLoading}
        t={t}
        renderStatusBadge={renderTaskStatusBadge}
        userRole={userRole}
        disableStartTimeUpdate={true}
        fetchCalendarData={fetchCalendarData}
        calendarStart={visibleStartDate}
        calendarEnd={visibleEndDate}
        allEmployees={allEmployees}
        isReadOnly={isReadOnly}
        onRemoveCleaner={(data) => {
          setSelectedOrderDetailId(data.orderDetailId);
          setSelectedEmployeeId(data.employeeId);
          setSelectedTaskDate(data.taskDate);
          setShowCleanerDeleteModal(true);
        }}
        context={"calendar"}
        conflictMap={conflictMap}
      />

      <UnavailabilitySidepanel
        open={leaveDrawerOpen}
        onClose={() => {
          setLeaveDrawerOpen(false);
          setSelectedLeaveData(null);
        }}
        data={selectedLeaveData}
        mode={isReadOnly ? "readonly" : "calendar"}
        t={t}
        onUpdated={handleUnavailabilityUpdated}
        onDecision={handleUnavailabilityDecision}
        decisionLoading={leaveDecisionLoading}
        conflictMap={conflictMap}
        onEmployeeOnLeave={(empName, onConfirm, onCancel) => {
          setEmployeeOnLeaveModal({
            show: true,
            employeeName: empName,
            onConfirm,
            onCancel,
          });
        }}
        onTaskConflict={(info, onConfirm, onCancel) => {  
          setPendingCombinedDropInfo({
            info: { revert: () => {} },
            leaveOnConfirm: onConfirm,
            leaveOnCancel: onCancel,
            issues: [{
              type: "taskConflict",
              employeeName: info?.employeeName,
              conflictTaskName: info?.conflictTaskName,
              conflictClientName: info?.conflictClientName,
              conflictStart: info?.conflictStart,
              conflictEnd: info?.conflictEnd,
            }],
          });
          setShowCombinedWarningModal(true);
        }}
        onCombinedIssues={(issues, onConfirm, onCancel) => {
          setPendingCombinedDropInfo({
            issues,
            info: { revert: () => {} },
            leaveOnConfirm: onConfirm,
            leaveOnCancel: onCancel,
          });
          setShowCombinedWarningModal(true);
        }}
        onPastDate={(fromEmployee, toEmployee, onConfirm, onCancel) => {
          setPendingDropInfo({ fromEmployee, toEmployee, onConfirm, onCancel });
          setShowPastDropModal(true);
        }}
      />
      <CreateOrderDrawer
        open={showCreateOrder}
        onClose={() => {
          setShowCreateOrder(false);
          setSelectedTimeRange({ start: null, end: null });
          setCreateOrderPreFill({ employeeId: null, clientId: null });
        }}
        selectedTimeRange={selectedTimeRange}
        preSelectedEmployeeId={createOrderPreFill.employeeId}
        preSelectedClientId={createOrderPreFill.clientId}
        conflictMap={conflictMap}
        leaveEvents={initialEvents.filter(e => e.extendedProps?.isLeaveBadge)}
        onCreated={() => {
          lastFetchKeyRef.current = null;
          initialFetchDoneRef.current = false;
        }}
        t={t}
      />
      <Modal
        show={showLeaveReassignModal}
        onHide={() => {
          setShowLeaveReassignModal(false);
          pendingLeaveReassignInfo?.info?.revert();
          setPendingLeaveReassignInfo(null);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon="exchange-alt" className="text-primary me-2" />
            {t("leaveReassignTitle")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            {pendingLeaveReassignInfo?.isSameEmployee
              ? t("leaveReassignDateChangeMessage", {
                employeeName: pendingLeaveReassignInfo?.oldEmployeeName,
                leaveType: pendingLeaveReassignInfo?.leaveType,
                newDate: pendingLeaveReassignInfo?.newStartDate,
              })
              : t("leaveReassignEmployeeChangeMessage", {
                leaveType: pendingLeaveReassignInfo?.leaveType,
                oldEmployeeName: pendingLeaveReassignInfo?.oldEmployeeName,
                newEmployeeName: pendingLeaveReassignInfo?.newEmployeeName,
                startDate: moment(pendingLeaveReassignInfo?.newStartDate ?? pendingLeaveReassignInfo?.leave?.StartDate).format("DD-MM-YYYY"),
                endDate: moment(pendingLeaveReassignInfo?.newEndDate ?? pendingLeaveReassignInfo?.leave?.EndDate).format("DD-MM-YYYY"),
              })
            }
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="falcon-default" size="sm" onClick={() => {
            setShowLeaveReassignModal(false);
            pendingLeaveReassignInfo?.info?.revert();
            setPendingLeaveReassignInfo(null);
          }}>
            {t("cancel")}
          </Button>
          <Button variant="primary" size="sm" onClick={async () => {
            const data = pendingLeaveReassignInfo;
            setShowLeaveReassignModal(false);
            setPendingLeaveReassignInfo(null);
            if (!data) return;
            try {
              const allRecords = await axios.get(
                `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/getAllUnavailability`,
                {
                  params: { customerId: localStorage.getItem("customerId") },
                  headers: { Authorization: process.env.REACT_APP_BasicAuthSecret }
                }
              );
              const matchingRecords = (allRecords.data || []).filter(
                r => r.RequestGroupId === data.leave.RequestGroupId
              );
              await Promise.all(
                matchingRecords.map(record =>
                  axios.patch(
                    `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/updateUnavailability/${record.UnavailabilityId}`,
                    { userId: data.effectiveEmployeeId, startDate: data.newStartDate, endDate: data.newEndDate },
                    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                  )
                )
              );
              const userId = localStorage.getItem("UserId");
              const leaveType = data.leave.Type === "sickness" ? t("sickLeave") : t("vacation");
              if (!data.isSameEmployee) {
                try {
                  const adminName = localStorage.getItem("UserName") || t("admin");
                  const leaveStart = data.newStartDate ?? data.leave?.StartDate;
                  const leaveEnd = data.newEndDate ?? data.leave?.EndDate;
                  const formattedStart = leaveStart ? moment(leaveStart).format("DD-MM-YYYY") : null;
                  const formattedEnd = leaveEnd ? moment(leaveEnd).format("DD-MM-YYYY") : null;
                  const dateLabel = formattedStart && formattedEnd && formattedStart !== formattedEnd
                    ? `${formattedStart} – ${formattedEnd}`
                    : formattedStart || "";

                  await axios.post(
                    `${process.env.REACT_APP_API_URL}/notificationsRoute/notification/create`,
                    {
                      message: t("in-AppNotifications.leaveRemovedMessage", {
                        leaveType,
                        date: dateLabel,
                        newEmployeeName: data.newEmployeeName,
                        adminName,
                      }),
                      raisedFrom: userId,
                      receivedTo: data.leave?.UserId,
                      type: "In-App",
                      isRead: false,
                      isActionRequired: false,
                      DateTime: moment.utc().format(),
                      sourceId: data.leave?.UnavailabilityId,
                      sourceType: "absence",
                      sourceDate: null,
                      eventKey: "LEAVE_REASSIGNED",
                    },
                    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                  );

                  await axios.post(
                    `${process.env.REACT_APP_API_URL}/notificationsRoute/notification/create`,
                    {
                      message: t("in-AppNotifications.leaveAssignedMessage", {
                        leaveType,
                        date: dateLabel,
                        oldEmployeeName: data.oldEmployeeName,
                        adminName,
                      }),
                      raisedFrom: userId,
                      receivedTo: data.effectiveEmployeeId,
                      type: "In-App",
                      isRead: false,
                      isActionRequired: false,
                      DateTime: moment.utc().format(),
                      sourceId: data.leave?.UnavailabilityId,
                      sourceType: "absence",
                      sourceDate: null,
                      eventKey: "LEAVE_REASSIGNED",
                    },
                    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                  );
                } catch (notifErr) {
                  console.error("Leave reassign notification failed (non-blocking):", notifErr);
                }
              }
              const oldCleaner = allEmployees.find(e => e.UserId === data.leave?.UserId);
              const newCleaner = allEmployees.find(e => e.UserId === data.effectiveEmployeeId);
              const leaveTypeLabel = data.leave.Type === "sickness" ? t("sickness") : t("vacation");
              const adminName = localStorage.getItem("UserName") || t("admin");

              const leaveStart = data.newStartDate ?? data.leave?.StartDate;
              const leaveEnd = data.newEndDate ?? data.leave?.EndDate;

              toast.success(t("leaveReassignedSuccess"), { position: "top-right" });

              notifyLeaveReassigned({
                customerId: localStorage.getItem("customerId"),
                leaveType: leaveTypeLabel,
                startDate: leaveStart,
                endDate: leaveEnd,
                startTime: data.startTime,
                endTime: data.endTime,
                isSameEmployee: data.isSameEmployee,
                adminName,
                oldEmployee: {
                  userId: data.leave?.UserId,
                  name: oldCleaner?.Name,
                  email: oldCleaner?.Emailaddress,
                  phone: oldCleaner?.PhoneNumber,
                },
                newEmployee: {
                  userId: data.effectiveEmployeeId,
                  name: newCleaner?.Name,
                  email: newCleaner?.Emailaddress,
                  phone: newCleaner?.PhoneNumber,
                },
                t,
              }).catch(err => console.error("Leave reassignment notification error (non-blocking):", err));
              lastFetchKeyRef.current = null;
              const api = calendarRef.current?.getApi();
              if (api?.view) {
                const start = moment(api.view.activeStart).toDate();
                const end = moment(api.view.activeEnd).subtract(1, "day").toDate();
                fetchCalendarData(start, end, false);
              }
            } catch (err) {
              console.error("Leave reassignment failed:", err);
              toast.error(t("leaveReassignFailed"), { position: "top-right" });
              data.info.revert();
            }
          }}>
            {t("confirm")}
          </Button>
        </Modal.Footer>
      </Modal>

      <OrderDetailDrawer
        open={orderDrawerOpen}
        onClose={() => {
          setOrderDrawerOpen(false);
          setSelectedOrderEventData(null);
          setSelectedOrderDayEvents([]);
        }}
        orderData={selectedOrderEventData}
        conflictMap={conflictMap}
        allOrderDayEvents={selectedOrderDayEvents}
        t={t}
        onAssignEmployee={() => {
          setOrderDrawerOpen(false);
          setShowCreateOrder(true);
        }}
        onViewAllEmployees={() => {
          const raw = selectedOrderEventData?.rawData ?? selectedOrderEventData;
          if (!raw?.OrderId) return;
          setOrderDrawerOpen(false);
          setSelectedOrderDayEvents([]);
          setInitialEvents([]);
          setResourceList([]);
          setSelectedOrderId(raw.OrderId);
          setSelectedOrderClient(selectedOrderEventData?.clientName ?? raw?.Relation?.Name ?? null);
          setSelectedDropdownOrderId(raw.OrderId);
          setSelectedClientPlanning(raw.RelationId ?? 'all');
          lastFetchKeyRef.current = null;
          fetchInProgressRef.current = false;
          const api = calendarRef.current?.getApi();
          if (api) {
            api.changeView('resourceTimelineWeek');
          }
          setTimeout(() => {
            const freshApi = calendarRef.current?.getApi();
            if (freshApi?.view) {
              const start = moment(freshApi.view.activeStart).toDate();
              const end = moment(freshApi.view.activeEnd).subtract(1, 'day').toDate();
              fetchCalendarData(start, end, false, 'drilldown');
            }
          }, 100);
        }}
      />
      <SchedulingIssuesModal
        show={showCombinedWarningModal}
        issues={pendingCombinedDropInfo?.issues || []}
        t={t}
        onCancel={() => {
          setShowCombinedWarningModal(false);
          if (pendingCombinedDropInfo?.leaveOnCancel) {
            pendingCombinedDropInfo.leaveOnCancel();
          } else {
            pendingCombinedDropInfo?.info?.revert();
          }
          setPendingCombinedDropInfo(null);
        }}
        onConfirm={() => {
          const data = pendingCombinedDropInfo;
          setShowCombinedWarningModal(false);
          setPendingCombinedDropInfo(null);
          if (data?.leaveOnConfirm) {
            data.leaveOnConfirm();
          } else if (data?.pendingSlotInfo) {
            const slotInfo = data.pendingSlotInfo;
            const isResourceView = currentView === "resourceTimelineWeek" || currentView === "resourceTimelineDay";
            if (isResourceView) {
              const dateOnly = moment(slotInfo.start).startOf('day').toDate();
              setSelectedTimeRange({ start: dateOnly, end: null, dateOnly: true });
            } else {
              setSelectedTimeRange({ start: slotInfo.start, end: slotInfo.end });
            }
            setShowCreateOrder(true);
          } else if (data?.info) {
            skipAllChecksRef.current = true;
            handleEventDrop(data.info);
          }
        }}
      />
    </>
  );
};

export default Calendar;